export const MenuIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_260_1508)">
        <path
          d="M4 6.5H20"
          stroke="#443F4D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 12.5H20"
          stroke="#443F4D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 18.5H20"
          stroke="#443F4D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_1508">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconClose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 18.75C17.9016 18.7512 17.8041 18.7318 17.7137 18.693C17.6233 18.6543 17.542 18.597 17.475 18.525L5.475 6.52499C5.175 6.22499 5.175 5.75999 5.475 5.45999C5.775 5.15999 6.24 5.15999 6.54 5.45999L18.525 17.475C18.825 17.775 18.825 18.24 18.525 18.54C18.375 18.69 18.18 18.765 18 18.765V18.75Z"
        fill="#444249"
      />
      <path
        d="M6 18.75C5.90164 18.7512 5.80411 18.7318 5.71369 18.6931C5.62328 18.6543 5.54197 18.5971 5.475 18.525C5.175 18.225 5.175 17.76 5.475 17.46L17.475 5.475C17.775 5.175 18.24 5.175 18.54 5.475C18.84 5.775 18.84 6.24 18.54 6.54L6.525 18.525C6.375 18.675 6.18 18.75 6 18.75Z"
        fill="#444249"
      />
    </svg>
  );
};

export const IconDown = ({ stroke = "#A9AACC" }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5719 6.80908L10.773 11.608C10.2062 12.1747 9.27885 12.1747 8.71211 11.608L3.91321 6.80908"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoadingIcon = () => {
  return (
    <svg
      ariaHidden="true"
      role="status"
      className="inline w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconUser = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5867 2.6665H10.4133C5.55999 2.6665 2.66666 5.55984 2.66666 10.4132V21.5865C2.66666 25.3332 4.38666 27.9065 7.41332 28.8798C8.29332 29.1865 9.30666 29.3332 10.4133 29.3332H21.5867C22.6933 29.3332 23.7067 29.1865 24.5867 28.8798C27.6133 27.9065 29.3333 25.3332 29.3333 21.5865V10.4132C29.3333 5.55984 26.44 2.6665 21.5867 2.6665ZM27.3333 21.5865C27.3333 24.4398 26.2133 26.2398 23.96 26.9865C22.6667 24.4398 19.6 22.6265 16 22.6265C12.4 22.6265 9.34666 24.4265 8.03999 26.9865H8.02666C5.79999 26.2665 4.66666 24.4532 4.66666 21.5998V10.4132C4.66666 6.65317 6.65332 4.6665 10.4133 4.6665H21.5867C25.3467 4.6665 27.3333 6.65317 27.3333 10.4132V21.5865Z"
        fill="#2E2B86"
      />
      <path
        d="M16 10.6665C13.36 10.6665 11.2267 12.7998 11.2267 15.4398C11.2267 18.0798 13.36 20.2265 16 20.2265C18.64 20.2265 20.7733 18.0798 20.7733 15.4398C20.7733 12.7998 18.64 10.6665 16 10.6665Z"
        fill="#2E2B86"
      />
    </svg>
  );
};

export const VSIcon = () => {
  return (
    <svg
      className="w-full h-full"
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00151 4.9458H2.45751L0.873513 0.7938H1.47351L2.26551 2.9938C2.35618 3.24447 2.44685 3.49247 2.53751 3.7378C2.61751 3.95113 2.68951 4.1458 2.75351 4.3218C2.82285 4.15113 2.89485 3.95647 2.96951 3.7378C3.02818 3.57247 3.11885 3.32447 3.24151 2.9938L4.02551 0.7938H4.60151L3.00151 4.9458ZM8.30908 1.9938H7.74108C7.64508 1.42313 7.29574 1.1378 6.69308 1.1378C6.04241 1.1378 5.71708 1.3778 5.71708 1.8578C5.71708 2.1618 5.92241 2.3618 6.33308 2.4578L7.35708 2.7058C8.01308 2.86047 8.34108 3.20447 8.34108 3.7378C8.34108 4.1698 8.17574 4.5058 7.84508 4.7458C7.55708 4.9538 7.18641 5.0578 6.73308 5.0578C6.10908 5.0578 5.64774 4.87913 5.34908 4.5218C5.22641 4.37247 5.14374 4.24713 5.10108 4.1458C5.05841 4.03913 5.03441 3.89247 5.02908 3.7058H5.61308C5.63441 4.0258 5.73308 4.25513 5.90908 4.3938C6.08508 4.53247 6.36774 4.6018 6.75708 4.6018C7.07708 4.6018 7.33041 4.5298 7.51708 4.3858C7.70374 4.2418 7.79708 4.04713 7.79708 3.8018C7.79708 3.4818 7.57574 3.27113 7.13308 3.1698L6.12508 2.9298C5.49041 2.78047 5.17308 2.42847 5.17308 1.8738C5.17308 1.5058 5.30908 1.21513 5.58108 1.0018C5.85841 0.788467 6.23441 0.6818 6.70908 0.6818C7.21041 0.6818 7.60774 0.820467 7.90108 1.0978C8.14641 1.33247 8.28241 1.63113 8.30908 1.9938Z"
        fill="#A9AACC"
      />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.6667C5.41668 1.66671 1.66668 5.41671 1.66668 10C1.66668 14.5834 5.41668 18.3334 10 18.3334C14.5833 18.3334 18.3333 14.5834 18.3333 10C18.3333 5.4167 14.5833 1.6667 10 1.6667Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.3334L10 9.16671"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0046 6.66663L9.99709 6.66663"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CheckedIcon = () => {
  return (
    <svg
      className="w-full h-full"
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 0C12.3475 0 0 12.3475 0 27.5C0 42.6525 12.3475 55 27.5 55C42.6525 55 55 42.6525 55 27.5C55 12.3475 42.6525 0 27.5 0ZM40.645 21.175L25.0525 36.7675C24.6675 37.1525 24.145 37.3725 23.595 37.3725C23.045 37.3725 22.5225 37.1525 22.1375 36.7675L14.355 28.985C13.5575 28.1875 13.5575 26.8675 14.355 26.07C15.1525 25.2725 16.4725 25.2725 17.27 26.07L23.595 32.395L37.73 18.26C38.5275 17.4625 39.8475 17.4625 40.645 18.26C41.4425 19.0575 41.4425 20.35 40.645 21.175Z"
        fill="#2E2B86"
      />
    </svg>
  );
};

export const ErrorIcon = () => {
  return (
    <svg
      className="w-full h-full"
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22_4)">
        <path
          d="M27.5 0C22.061 0 16.7442 1.61285 12.2218 4.63459C7.69948 7.65632 4.17474 11.9512 2.09333 16.9762C0.0119154 22.0012 -0.532676 27.5305 0.528417 32.865C1.58951 38.1995 4.20863 43.0995 8.05458 46.9454C11.9005 50.7914 16.8006 53.4105 22.135 54.4716C27.4695 55.5327 32.9988 54.9881 38.0238 52.9067C43.0488 50.8253 47.3437 47.3005 50.3654 42.7782C53.3872 38.2558 55 32.939 55 27.5C54.9921 20.209 52.0923 13.2188 46.9367 8.06327C41.7812 2.90773 34.791 0.00788581 27.5 0ZM37.2213 33.9831C37.6509 34.4129 37.8922 34.9957 37.8922 35.6033C37.8922 36.211 37.6509 36.7938 37.2213 37.2235C36.7842 37.6391 36.2042 37.8709 35.6011 37.8709C34.998 37.8709 34.4179 37.6391 33.9808 37.2235L27.5 30.7404L21.0192 37.2235C20.5865 37.6476 20.0048 37.8852 19.399 37.8852C18.7931 37.8852 18.2114 37.6476 17.7788 37.2235C17.3491 36.7938 17.1078 36.211 17.1078 35.6033C17.1078 34.9957 17.3491 34.4129 17.7788 33.9831L24.2596 27.5L17.7788 21.0169C17.5599 20.8055 17.3853 20.5526 17.2652 20.273C17.1451 19.9934 17.0819 19.6927 17.0792 19.3884C17.0766 19.0841 17.1346 18.7824 17.2498 18.5007C17.365 18.2191 17.5352 17.9632 17.7504 17.7481C17.9655 17.5329 18.2214 17.3627 18.503 17.2475C18.7847 17.1323 19.0864 17.0743 19.3907 17.0769C19.695 17.0796 19.9957 17.1428 20.2753 17.2629C20.5549 17.383 20.8078 17.5576 21.0192 17.7765L27.5 24.2596L33.9808 17.7765C34.1922 17.5576 34.4451 17.383 34.7247 17.2629C35.0043 17.1428 35.305 17.0796 35.6093 17.0769C35.9136 17.0743 36.2154 17.1323 36.497 17.2475C36.7786 17.3627 37.0345 17.5329 37.2497 17.7481C37.4648 17.9632 37.635 18.2191 37.7502 18.5007C37.8655 18.7824 37.9234 19.0841 37.9208 19.3884C37.9182 19.6927 37.8549 19.9934 37.7348 20.273C37.6147 20.5526 37.4401 20.8055 37.2213 21.0169L30.7404 27.5L37.2213 33.9831Z"
          fill="#2E2B86"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_4">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PaymentPendingIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 1.1001C24.3408 1.1001 21.252 1.6523 18.3172 2.7413L19.0828 4.8038C21.7766 3.80514 24.6271 3.2959 27.5 3.3001C40.8441 3.3001 51.7 14.156 51.7 27.5001C51.7 40.8442 40.8441 51.7001 27.5 51.7001C14.1559 51.7001 3.30001 40.8442 3.30001 27.5001C3.30212 23.9346 4.09206 20.4135 5.61333 17.1888C7.13461 13.9641 9.34963 11.1153 12.1 8.8463V16.5001H14.3V5.5001H3.30001V7.7001H10.0386C7.22964 10.1777 4.97991 13.2245 3.43879 16.6383C1.89767 20.052 1.10043 23.7546 1.10001 27.5001C1.10001 42.0564 12.9437 53.9001 27.5 53.9001C42.0563 53.9001 53.9 42.0564 53.9 27.5001C53.9 12.9438 42.0563 1.1001 27.5 1.1001Z"
        fill="white"
      />
      <path
        d="M20.9 36.3H18.7V38.5H36.3V36.3H34.1V32.5446L29.0554 27.5L34.1 22.4554V18.7H36.3V16.5H18.7V18.7H20.9V22.4554L25.9446 27.5L20.9 32.5446V36.3ZM23.1 21.5446V18.7H31.9V21.5446L27.5 25.9446L23.1 21.5446ZM27.5 29.0554L31.9 33.4554V36.3H23.1V33.4554L27.5 29.0554ZM20.9 42.9H23.1V45.1H20.9V42.9ZM26.4 42.9H28.6V45.1H26.4V42.9ZM31.9 42.9H34.1V45.1H31.9V42.9Z"
        fill="white"
      />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 16L28 5.48001C26.9 4.4961 25.4759 3.95215 24 3.95215C22.5241 3.95215 21.1001 4.4961 20 5.48001L8.00001 16C7.36474 16.5682 6.85781 17.2651 6.51295 18.0445C6.16809 18.8239 5.99323 19.6678 6.00001 20.52V38C6.00001 39.5913 6.63215 41.1174 7.75737 42.2427C8.88258 43.3679 10.4087 44 12 44H36C37.5913 44 39.1174 43.3679 40.2426 42.2427C41.3679 41.1174 42 39.5913 42 38V20.5C42.0039 19.6511 41.8277 18.8111 41.4829 18.0354C41.1382 17.2597 40.6327 16.5659 40 16ZM28 40H20V30C20 29.4696 20.2107 28.9609 20.5858 28.5858C20.9609 28.2107 21.4696 28 22 28H26C26.5304 28 27.0391 28.2107 27.4142 28.5858C27.7893 28.9609 28 29.4696 28 30V40ZM38 38C38 38.5304 37.7893 39.0392 37.4142 39.4142C37.0391 39.7893 36.5304 40 36 40H32V30C32 28.4087 31.3679 26.8826 30.2426 25.7574C29.1174 24.6322 27.5913 24 26 24H22C20.4087 24 18.8826 24.6322 17.7574 25.7574C16.6321 26.8826 16 28.4087 16 30V40H12C11.4696 40 10.9609 39.7893 10.5858 39.4142C10.2107 39.0392 10 38.5304 10 38V20.5C10.0004 20.216 10.0612 19.9354 10.1784 19.6768C10.2957 19.4181 10.4667 19.1874 10.68 19L22.68 8.50001C23.045 8.17937 23.5142 8.00254 24 8.00254C24.4858 8.00254 24.955 8.17937 25.32 8.50001L37.32 19C37.5333 19.1874 37.7043 19.4181 37.8216 19.6768C37.9388 19.9354 37.9996 20.216 38 20.5V38Z"
        fill="black"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 21.6233C29.7554 21.6233 34.437 16.9417 34.437 11.187C34.437 5.43237 29.7554 0.75 24 0.75C18.2446 0.75 13.563 5.43237 13.563 11.187C13.563 16.9417 18.2446 21.6233 24 21.6233ZM24 5.25C27.2739 5.25 29.937 7.91309 29.937 11.187C29.937 14.4602 27.2739 17.1233 24 17.1233C20.7261 17.1233 18.063 14.4602 18.063 11.187C18.063 7.91309 20.7261 5.25 24 5.25ZM35.6382 24.8994H12.3618C6.19922 24.8994 1.18652 29.9129 1.18652 36.0747C1.18652 42.2366 6.19922 47.25 12.3618 47.25H35.6382C41.8008 47.25 46.8135 42.2366 46.8135 36.0747C46.8135 29.9128 41.8008 24.8994 35.6382 24.8994ZM35.6382 42.75H12.3618C8.68067 42.75 5.68652 39.7551 5.68652 36.0747C5.68652 32.3943 8.68066 29.3994 12.3618 29.3994H35.6382C39.3193 29.3994 42.3135 32.3943 42.3135 36.0747C42.3135 39.7551 39.3193 42.75 35.6382 42.75Z"
        fill="black"
      />
    </svg>
  );
};

export const TicketIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28_12)">
        <path
          d="M40.2249 37.913C40.2396 37.9142 40.2539 37.9147 40.268 37.9147C40.5239 37.9147 40.7417 37.7185 40.7641 37.4589L41.2425 31.8716C41.2658 31.5974 41.0627 31.356 40.7885 31.3324C40.5072 31.3063 40.2726 31.5125 40.2492 31.7864L39.7708 37.3737C39.7476 37.648 39.9507 37.8893 40.2249 37.913ZM36.8906 40.4071C37.1653 40.43 37.4062 40.2271 37.4299 39.9531L38.3811 28.8468C38.4044 28.5726 38.2012 28.3312 37.927 28.3075C37.6479 28.2839 37.4114 28.4873 37.3878 28.7616L36.4366 39.8678C36.4132 40.1422 36.6164 40.3835 36.8906 40.4071Z"
          fill="black"
        />
        <path
          d="M46.799 27.5784C45.2441 27.2246 43.9684 26.208 43.2508 24.8625L44.2226 24.414C44.8805 24.1149 45.2242 23.3674 45.0249 22.6847C44.3322 20.4124 45.2542 17.9256 47.2575 16.6399C47.8655 16.2561 48.0897 15.4639 47.7858 14.796L47.2675 13.6797C47.1529 13.4305 46.8589 13.3209 46.6097 13.4355C46.2708 13.5899 45.8722 13.4404 45.7177 13.1066C45.5632 12.7676 45.7127 12.369 46.0465 12.2146C46.2957 12.1 46.4053 11.8059 46.2907 11.5567L45.7326 10.3408C45.6777 10.2212 45.5781 10.1314 45.4535 10.0817C45.3289 10.0368 45.1943 10.0417 45.0697 10.0967C44.9103 10.1764 44.7259 10.1813 44.5565 10.1215C44.392 10.0568 44.2575 9.93223 44.1827 9.7677C44.0282 9.43385 44.1777 9.03513 44.5116 8.88063C44.7607 8.76607 44.8703 8.47207 44.7558 8.21791L44.1977 7.00685C44.1428 6.88723 44.0432 6.79263 43.9186 6.74773C43.794 6.70291 43.6545 6.70798 43.5349 6.76273C43.3754 6.83754 43.191 6.84757 43.0216 6.7827C42.8572 6.72298 42.7225 6.59838 42.6478 6.43385C42.608 6.34423 42.588 6.24945 42.588 6.15476C42.588 5.9006 42.7276 5.66145 42.9767 5.54679C43.2258 5.43213 43.3355 5.13326 43.2209 4.88407L42.7027 3.7677C42.3987 3.10001 41.6512 2.75613 40.9684 2.96548C38.686 3.65313 36.1993 2.73626 34.9186 0.727946C34.5299 0.13479 33.7425 -0.0893667 33.0797 0.214665L3.7724 13.7047C3.11455 14.0087 2.76571 14.7561 2.97009 15.4389C3.65784 17.7112 2.74087 20.198 0.742491 21.4788C0.134522 21.8625 -0.0897275 22.6549 0.21421 23.3227L0.73246 24.4389C0.787304 24.5635 0.88696 24.6533 1.01155 24.698C1.07634 24.723 1.15115 24.7329 1.2209 24.7279C1.17102 24.8525 1.13615 24.9871 1.12621 25.1316L1.02159 26.3625C1.00659 26.492 1.05149 26.6266 1.13615 26.7262C1.2209 26.8259 1.34052 26.8908 1.47505 26.9007C1.65449 26.9157 1.81893 27.0004 1.93359 27.1399C2.04815 27.2744 2.10299 27.4537 2.08809 27.6332C2.05818 28.0119 1.71927 28.2811 1.36049 28.2461C1.07643 28.2212 0.842241 28.4254 0.817304 28.6996L0.707616 30.035C0.69271 30.1696 0.737523 30.2993 0.822179 30.399C0.906929 30.4986 1.02655 30.5633 1.16109 30.5734C1.5299 30.6082 1.80393 30.9371 1.77402 31.3059C1.74412 31.6747 1.41524 31.9538 1.04643 31.9189C0.767335 31.899 0.528179 32.0983 0.503241 32.3724L0.388585 33.7079C0.378648 33.8424 0.42346 33.972 0.50821 34.0716C0.59296 34.1763 0.712585 34.2362 0.847116 34.2511C1.21593 34.2809 1.48996 34.6099 1.46005 34.9787C1.43015 35.3524 1.10624 35.6266 0.727491 35.5966C0.448398 35.5716 0.21421 35.7759 0.189273 36.05L0.0846475 37.2809C0.024835 38.0135 0.503241 38.6812 1.20093 38.8408C3.53315 39.3691 5.24746 41.4072 5.36699 43.7943C5.4119 44.5069 5.98996 45.09 6.71746 45.1497L38.995 47.9156C39.0349 47.9206 39.0798 47.9206 39.1196 47.9206C39.7973 47.9206 40.4003 47.4572 40.5548 46.8043C41.0781 44.477 43.1163 42.7627 45.5033 42.6333C46.221 42.5984 46.814 42.0202 46.8738 41.2877L46.9784 40.0568C46.9934 39.9223 46.9485 39.7927 46.8638 39.6931C46.7791 39.5884 46.6596 39.5285 46.5249 39.5136C46.3455 39.4988 46.1811 39.4189 46.0665 39.2794C45.9518 39.1399 45.8971 38.9656 45.912 38.7861C45.9269 38.6068 46.0117 38.4424 46.1462 38.3277C46.2858 38.213 46.4602 38.1532 46.6395 38.1732C46.9186 38.1932 47.1577 37.9889 47.1827 37.7148L47.2923 36.3843C47.3073 36.2497 47.2624 36.1202 47.1776 36.0205C47.0929 35.9158 46.9733 35.856 46.8387 35.8411C46.6593 35.8261 46.4948 35.7414 46.3803 35.6069C46.2656 35.4673 46.2109 35.2928 46.2258 35.1136C46.2407 34.9341 46.3254 34.7696 46.46 34.655C46.5996 34.5356 46.7789 34.4807 46.9533 34.4957C47.2324 34.5205 47.4715 34.3162 47.4965 34.0421L47.6111 32.7066C47.6211 32.5771 47.5762 32.4475 47.4915 32.3429C47.4067 32.2432 47.2872 32.1834 47.1526 32.1685C46.9732 32.1534 46.8137 32.0688 46.6942 31.9292C46.5795 31.7947 46.5247 31.6203 46.5397 31.4408C46.5696 31.087 46.8636 30.8179 47.2074 30.8179C47.2324 30.8179 47.2523 30.8228 47.2722 30.8228C47.5463 30.8478 47.7855 30.6435 47.8104 30.3694L47.9151 29.1385C47.9751 28.4057 47.4967 27.7329 46.799 27.5784ZM2.06315 25.8392C2.1329 25.3009 2.06812 25.1465 2.23255 24.9471C2.24755 24.9721 2.31721 25.6549 2.06315 25.8392ZM5.0083 22.8591C6.31893 21.2595 7.06649 19.2412 7.1113 17.1731C7.12124 16.7445 7.35552 16.3707 7.71927 16.2014L32.4069 4.83926C32.5415 4.77945 32.686 4.74448 32.8356 4.74448C33.0798 4.74448 33.3339 4.83429 33.5432 5.00876C35.1428 6.31432 37.1662 7.06188 39.2392 7.10679C39.6677 7.11673 40.0415 7.34595 40.211 7.71476L43.1611 14.1233C43.3305 14.4921 43.2657 14.9257 42.9917 15.2596C41.6761 16.8642 40.9286 18.8825 40.8787 20.9506C40.8688 21.3792 40.6345 21.753 40.2708 21.9224L15.583 33.2843C15.2193 33.4538 14.7807 33.389 14.4518 33.115C12.8472 31.8093 10.8289 31.0618 8.76084 31.017C8.33221 31.007 7.95852 30.7728 7.78902 30.404L4.8388 23.9954C4.6694 23.6266 4.73418 23.193 5.0083 22.8591ZM43.1761 38.4073C43.1412 38.811 42.8671 39.1598 42.4634 39.3143C40.5249 40.0618 38.8654 41.4522 37.799 43.2364C37.5797 43.6052 37.186 43.8194 36.7823 43.7794L9.59793 41.4523C9.19424 41.4174 8.8454 41.1433 8.68593 40.7397C7.93846 38.8061 6.54805 37.1566 4.76399 36.0902C4.39518 35.8659 4.18593 35.4772 4.2208 35.0735L4.53974 31.341C4.85868 31.2364 5.20752 31.3759 5.35199 31.6848C5.50649 32.0187 5.36193 32.4174 5.02312 32.5768C4.77393 32.6914 4.66434 32.9854 4.7789 33.2346L5.29715 34.3559C5.60109 35.0237 6.34865 35.3626 7.03134 35.1531C7.96321 34.8741 8.92499 34.8692 9.83202 35.0884L9.61771 37.5702C9.59774 37.8443 9.79715 38.0884 10.0712 38.1084C10.0862 38.1134 10.1011 38.1134 10.1161 38.1134C10.3702 38.1134 10.5895 37.914 10.6145 37.6549L10.8038 35.4223C11.7108 35.841 12.5081 36.5088 13.0713 37.3957C13.141 37.4955 13.2208 37.5902 13.3056 37.6699L13.0415 38.2978C12.9069 38.6118 12.9917 38.9756 13.2507 39.1999C13.5098 39.4191 13.8786 39.454 14.1677 39.2746L15.3238 38.577L16.3504 39.464C16.4948 39.5936 16.6792 39.6584 16.8636 39.6584C17.0032 39.6584 17.1427 39.6186 17.2673 39.5438C17.5613 39.3645 17.7059 39.0256 17.6261 38.6916L17.3171 37.376L18.4782 36.6783C18.6875 36.5487 18.822 36.3294 18.847 36.0952L19.8536 35.6318L21.229 36.8179L20.4067 38.7615C20.2522 39.1252 20.3469 39.5438 20.6459 39.8079C20.9449 40.067 21.3785 40.102 21.7174 39.8975L23.5213 38.8062L25.116 40.1916C25.2854 40.3362 25.4997 40.4109 25.714 40.4109C25.8735 40.4109 26.0379 40.3712 26.1875 40.2814C26.5264 40.0771 26.6908 39.6784 26.6011 39.2946L26.1227 37.2365L27.9266 36.1501C28.2655 35.9458 28.4349 35.5471 28.3452 35.1634C28.2555 34.7748 27.9266 34.4957 27.533 34.4607L25.4349 34.2813L25.1758 33.18L39.6825 26.5072C40.4798 28.0819 41.7108 29.4225 43.2307 30.3294C43.6044 30.5537 43.8137 30.9424 43.7788 31.346L43.1761 38.4073Z"
          fill="black"
        />
        <path
          d="M34.789 38.0735L33.6279 38.7713L33.9369 40.0868C34.0167 40.4207 33.8721 40.7647 33.5781 40.939C33.4535 41.0138 33.314 41.0536 33.1745 41.0536C32.99 41.0536 32.8056 40.9889 32.6612 40.8593L31.6346 39.9772L30.4785 40.6748C30.1895 40.8492 29.8157 40.8193 29.5615 40.5951C29.3024 40.3708 29.2176 40.0071 29.3522 39.693L29.8755 38.4521L28.8539 37.5651C28.5948 37.3408 28.51 36.982 28.6446 36.6681C28.7792 36.3542 29.0931 36.1598 29.437 36.1897L30.7825 36.3042L31.3058 35.0633C31.4404 34.7495 31.7543 34.555 32.0982 34.5849C32.4371 34.6148 32.7161 34.8541 32.7959 35.1879L33.0998 36.5036L34.4503 36.6182C34.7892 36.648 35.0682 36.8923 35.1429 37.2262C35.2226 37.5551 35.078 37.8991 34.789 38.0735ZM9.72673 28.7037C9.84158 28.9534 10.1372 29.0637 10.3876 28.948C10.6377 28.8329 10.747 28.537 10.6319 28.2872L8.29667 23.214C8.18183 22.9639 7.8852 22.8551 7.63583 22.9697C7.3857 23.0848 7.27639 23.3807 7.39152 23.6305L9.72673 28.7037ZM13.6927 29.9145C13.8086 30.1664 14.1062 30.2732 14.3536 30.1588C14.6037 30.0437 14.713 29.7478 14.5979 29.498L9.95623 19.4134C9.84139 19.1633 9.54477 19.0542 9.29539 19.1691C9.04527 19.2842 8.93595 19.5801 9.05108 19.8299L13.6927 29.9145ZM39.7032 14.906C39.7871 15.0885 39.9675 15.1962 40.156 15.1962C40.2259 15.1962 40.2966 15.1814 40.364 15.1502C40.6142 15.0351 40.7235 14.7392 40.6084 14.4893L38.2731 9.41616C38.1583 9.16604 37.8624 9.057 37.6123 9.17185C37.3622 9.28697 37.2529 9.58285 37.368 9.83269L39.7032 14.906ZM38.0435 18.7065C38.1274 18.889 38.3077 18.9966 38.4963 18.9966C38.5661 18.9966 38.6369 18.9819 38.7043 18.9508C38.9544 18.8357 39.0637 18.5398 38.9486 18.29L34.307 8.20538C34.1921 7.95544 33.8962 7.84594 33.6461 7.96107C33.396 8.07619 33.2867 8.37207 33.4018 8.62191L38.0435 18.7065ZM29.372 24.11C29.1827 24.4538 28.789 24.6333 28.4053 24.5586L26.3421 24.1449L25.3156 25.9738C25.1511 26.2679 24.8471 26.4422 24.5232 26.4422C24.4634 26.4422 24.4036 26.4373 24.3438 26.4222C23.9551 26.3475 23.666 26.0287 23.6162 25.6349L23.372 23.5519L21.3138 23.1432C20.9251 23.0635 20.6311 22.7495 20.5862 22.3558C20.5413 21.9621 20.7506 21.5884 21.1094 21.4239L23.018 20.5468L22.7738 18.4638C22.724 18.07 22.9333 17.6963 23.2921 17.5268C23.6509 17.3623 24.0745 17.4472 24.3436 17.7361L25.7689 19.281L27.6775 18.4039C28.0313 18.2393 28.4549 18.3192 28.724 18.6131C28.9931 18.9022 29.043 19.3258 28.8486 19.6747L27.8221 21.5035L29.2474 23.0484C29.5166 23.3376 29.5665 23.7662 29.372 24.11ZM36.0996 21.0403C35.9302 21.3393 35.5963 21.4938 35.2625 21.424L33.9419 21.1649L33.284 22.3359C33.1445 22.5851 32.8804 22.7347 32.6014 22.7347C32.5516 22.7347 32.5017 22.7297 32.4469 22.7197C32.113 22.655 31.8638 22.3808 31.8239 22.0419L31.6644 20.7065L30.3488 20.4473C30.015 20.3775 29.7608 20.1083 29.721 19.7695C29.6811 19.4307 29.8605 19.1067 30.1745 18.9671L31.3954 18.4041L31.2359 17.0686C31.196 16.7296 31.3754 16.4058 31.6844 16.2662C31.9984 16.1216 32.3571 16.1964 32.5913 16.4456L33.5033 17.4323L34.7242 16.8692C35.0332 16.7296 35.397 16.7994 35.6262 17.0486C35.8604 17.3028 35.9003 17.6665 35.7358 17.9656L35.078 19.1366L35.99 20.1283C36.2242 20.3774 36.2641 20.7413 36.0996 21.0403ZM21.289 27.8575C21.1246 28.1566 20.7906 28.311 20.4518 28.2413L19.1313 27.9821L18.4734 29.1533C18.3338 29.4024 18.0747 29.552 17.7907 29.552C17.7409 29.552 17.6911 29.5468 17.6362 29.5369C17.3023 29.4722 17.0532 29.1981 17.0133 28.8592L16.8588 27.5237L15.5381 27.2646C15.2043 27.1947 14.9501 26.9258 14.9102 26.5868C14.8703 26.2479 15.0546 25.9239 15.3636 25.7845L16.5845 25.2214L16.4251 23.8859C16.3852 23.5471 16.5696 23.2231 16.8785 23.0835C17.1875 22.9391 17.5463 23.0088 17.7805 23.2629L18.6925 24.2497L19.9134 23.6866C20.2224 23.547 20.5862 23.6168 20.8154 23.8659C21.0497 24.1151 21.0895 24.4838 20.9251 24.7829L20.2672 25.9539L21.1792 26.9407C21.4136 27.1947 21.4535 27.5586 21.289 27.8575ZM12.6995 19.0384C12.7694 19.0384 12.8402 19.0238 12.9076 18.9926L31.1629 10.59C31.413 10.4749 31.5223 10.179 31.4072 9.92916C31.292 9.67922 30.996 9.57 30.7463 9.68485L12.491 18.0875C12.2409 18.2026 12.1316 18.4985 12.2467 18.7483C12.3306 18.9308 12.5109 19.0384 12.6995 19.0384Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_12">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1 37.1249H9.9C8.25 37.1249 6.875 35.7499 6.875 34.0999V11.8937C6.875 10.2437 7.975 8.86865 9.41875 8.86865H10.9312V10.8624H9.41875C9.2125 10.8624 8.9375 11.2749 8.9375 11.8937V34.0999C8.9375 34.6499 9.41875 35.1312 9.96875 35.1312H34.1688C34.7188 35.1312 35.2 34.6499 35.2 34.0999V11.8937C35.2 11.2749 34.8563 10.8624 34.7188 10.8624H33.2062V8.86865H34.7188C36.0938 8.86865 37.2625 10.2437 37.2625 11.8937V34.0999C37.125 35.7499 35.75 37.1249 34.1 37.1249Z"
        fill="#134563"
      />
      <path
        d="M13.9562 12.9249C13.4062 12.9249 12.925 12.4437 12.925 11.8937V7.8374C12.925 7.2874 13.4062 6.80615 13.9562 6.80615C14.5062 6.80615 14.9875 7.2874 14.9875 7.8374V11.8937C14.9187 12.4437 14.5062 12.9249 13.9562 12.9249ZM30.0437 12.9249C29.4937 12.9249 29.0125 12.4437 29.0125 11.8937V7.8374C29.0125 7.2874 29.4937 6.80615 30.0437 6.80615C30.5937 6.80615 31.075 7.2874 31.075 7.8374V11.8937C31.075 12.4437 30.5937 12.9249 30.0437 12.9249ZM16.9812 8.86865H27.0187V10.9312H16.9812V8.86865ZM8.86874 14.9187H35.1312V16.9812H8.86874V14.9187ZM31.075 18.9749H33.0687V20.9687H31.075V18.9749ZM27.0187 18.9749H29.0812V20.9687H27.0187V18.9749ZM23.0312 18.9749H25.025V20.9687H23.0312V18.9749ZM18.975 18.9749H20.9687V20.9687H18.975V18.9749ZM14.9187 18.9749H16.9812V20.9687H14.9187V18.9749ZM31.075 23.0312H33.0687V25.0249H31.075V23.0312ZM27.0187 23.0312H29.0812V25.0249H27.0187V23.0312ZM23.0312 23.0312H25.025V25.0249H23.0312V23.0312ZM18.975 23.0312H20.9687V25.0249H18.975V23.0312ZM14.9187 23.0312H16.9812V25.0249H14.9187V23.0312ZM10.9312 23.0312H12.925V25.0249H10.9312V23.0312ZM31.075 27.0187H33.0687V29.0812H31.075V27.0187ZM27.0187 27.0187H29.0812V29.0812H27.0187V27.0187ZM23.0312 27.0187H25.025V29.0812H23.0312V27.0187ZM18.975 27.0187H20.9687V29.0812H18.975V27.0187ZM14.9187 27.0187H16.9812V29.0812H14.9187V27.0187ZM10.9312 27.0187H12.925V29.0812H10.9312V27.0187ZM27.0187 31.0749H29.0812V33.0687H27.0187V31.0749ZM23.0312 31.0749H25.025V33.0687H23.0312V31.0749ZM18.975 31.0749H20.9687V33.0687H18.975V31.0749ZM14.9187 31.0749H16.9812V33.0687H14.9187V31.0749ZM10.9312 31.0749H12.925V33.0687H10.9312V31.0749Z"
        fill="#134563"
      />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 6.5H14.5C14.2348 6.5 13.9804 6.60536 13.7929 6.79289C13.6054 6.98043 13.5 7.23478 13.5 7.5C13.5 7.76522 13.6054 8.01957 13.7929 8.20711C13.9804 8.39464 14.2348 8.5 14.5 8.5H19.5C19.7652 8.5 20.0196 8.60536 20.2071 8.79289C20.3946 8.98043 20.5 9.23478 20.5 9.5V19.22L18.93 17.77C18.7456 17.5973 18.5026 17.5009 18.25 17.5H9.5C9.23478 17.5 8.98043 17.3946 8.79289 17.2071C8.60536 17.0196 8.5 16.7652 8.5 16.5V14.5C8.5 14.2348 8.39464 13.9804 8.20711 13.7929C8.01957 13.6054 7.76522 13.5 7.5 13.5C7.23478 13.5 6.98043 13.6054 6.79289 13.7929C6.60536 13.9804 6.5 14.2348 6.5 14.5V16.5C6.5 17.2957 6.81607 18.0587 7.37868 18.6213C7.94129 19.1839 8.70435 19.5 9.5 19.5H17.86L20.86 22.23C21.0444 22.4027 21.2874 22.4991 21.54 22.5C21.6772 22.4985 21.8128 22.4714 21.94 22.42C22.1189 22.3419 22.271 22.2132 22.3776 22.0497C22.4842 21.8863 22.5407 21.6952 22.54 21.5V9.5C22.54 9.10265 22.4611 8.70924 22.3079 8.34264C22.1546 7.97603 21.9301 7.64352 21.6472 7.36441C21.3644 7.08531 21.0289 6.86517 20.6603 6.71678C20.2917 6.56839 19.8973 6.4947 19.5 6.5ZM9.5 11.5C9.81647 11.501 10.1287 11.427 10.4109 11.2838C10.6932 11.1407 10.9375 10.9327 11.1237 10.6768C11.3099 10.4209 11.4327 10.1245 11.4821 9.81188C11.5314 9.49928 11.5059 9.17943 11.4076 8.87863C11.3092 8.57782 11.1409 8.30463 10.9165 8.08153C10.692 7.85843 10.4178 7.69178 10.1164 7.59527C9.81503 7.49877 9.49503 7.47516 9.18274 7.5264C8.87044 7.57763 8.57476 7.70225 8.32 7.89L6.57 7.09L8.48 6.21C8.78188 6.39326 9.12691 6.49332 9.48 6.5C9.87556 6.5 10.2622 6.3827 10.5911 6.16294C10.92 5.94318 11.1764 5.63082 11.3278 5.26537C11.4791 4.89992 11.5187 4.49778 11.4416 4.10982C11.3644 3.72186 11.1739 3.36549 10.8942 3.08579C10.6145 2.80608 10.2581 2.6156 9.87018 2.53843C9.48222 2.46126 9.08009 2.50087 8.71463 2.65224C8.34918 2.80362 8.03682 3.05996 7.81706 3.38886C7.5973 3.71776 7.48 4.10444 7.48 4.5L5.58 5.37C5.26359 5.14436 4.8883 5.01579 4.5 5C3.96957 5 3.46086 5.21071 3.08579 5.58579C2.71071 5.96086 2.5 6.46957 2.5 7C2.5 7.53043 2.71071 8.03914 3.08579 8.41421C3.46086 8.78929 3.96957 9 4.5 9C4.82489 8.99673 5.1441 8.91435 5.43 8.76L7.52 9.76C7.58303 10.2408 7.81858 10.6823 8.1828 11.0023C8.54702 11.3224 9.01512 11.4993 9.5 11.5Z"
        fill="black"
      />
    </svg>
  );
};

export const SignInIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38 8H34C33.4696 8 32.9609 8.21071 32.5858 8.58579C32.2107 8.96086 32 9.46957 32 10C32 10.5304 32.2107 11.0391 32.5858 11.4142C32.9609 11.7893 33.4696 12 34 12H36V36H34C33.4696 36 32.9609 36.2107 32.5858 36.5858C32.2107 36.9609 32 37.4696 32 38C32 38.5304 32.2107 39.0391 32.5858 39.4142C32.9609 39.7893 33.4696 40 34 40H38C38.5304 40 39.0391 39.7893 39.4142 39.4142C39.7893 39.0391 40 38.5304 40 38V10C40 9.46957 39.7893 8.96086 39.4142 8.58579C39.0391 8.21071 38.5304 8 38 8ZM23.6 14.8C23.2817 14.3757 22.8079 14.0951 22.2828 14.0201C21.7577 13.9451 21.2243 14.0817 20.8 14.4C20.3757 14.7183 20.0951 15.1921 20.0201 15.7172C19.9451 16.2423 20.0817 16.7757 20.4 17.2L24 22H8C7.46957 22 6.96086 22.2107 6.58579 22.5858C6.21071 22.9609 6 23.4696 6 24C6 24.5304 6.21071 25.0391 6.58579 25.4142C6.96086 25.7893 7.46957 26 8 26H24.18L20.74 30.88C20.5865 31.095 20.4772 31.3382 20.4182 31.5957C20.3592 31.8531 20.3519 32.1197 20.3965 32.38C20.4411 32.6404 20.5369 32.8893 20.6782 33.1124C20.8196 33.3355 21.0037 33.5284 21.22 33.68C21.56 33.9173 21.9654 34.0432 22.38 34.04C22.6973 34.0385 23.0097 33.9616 23.2914 33.8155C23.5731 33.6695 23.816 33.4585 24 33.2L29.64 25.2C29.8903 24.8575 30.0252 24.4442 30.0252 24.02C30.0252 23.5958 29.8903 23.1825 29.64 22.84L23.6 14.8Z"
        fill="black"
      />
    </svg>
  );
};

export const ArrowDownIcon = () => {
  return (
    <svg
      width={19}
      height={18}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.329 6.73633L10.6208 11.5352C10.0647 12.102 9.15487 12.102 8.59884 11.5352L3.89062 6.73633"
        stroke="#A9AACC"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// =>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> new Icon
export const DateIcon = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_49_680)">
        <path
          d="M4 7.34192C4 6.81149 4.21071 6.30278 4.58579 5.92771C4.96086 5.55263 5.46957 5.34192 6 5.34192H18C18.5304 5.34192 19.0391 5.55263 19.4142 5.92771C19.7893 6.30278 20 6.81149 20 7.34192V19.3419C20 19.8724 19.7893 20.3811 19.4142 20.7561C19.0391 21.1312 18.5304 21.3419 18 21.3419H6C5.46957 21.3419 4.96086 21.1312 4.58579 20.7561C4.21071 20.3811 4 19.8724 4 19.3419V7.34192Z"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 3.34192V7.34192"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 3.34192V7.34192"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 11.3419H20"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 15.3419H12"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.3419V18.3419"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49_680">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.341919)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_49_684)">
        <path
          d="M3 12.3419C3 13.5238 3.23279 14.6941 3.68508 15.7861C4.13738 16.878 4.80031 17.8702 5.63604 18.7059C6.47177 19.5416 7.46392 20.2045 8.55585 20.6568C9.64778 21.1091 10.8181 21.3419 12 21.3419C13.1819 21.3419 14.3522 21.1091 15.4442 20.6568C16.5361 20.2045 17.5282 19.5416 18.364 18.7059C19.1997 17.8702 19.8626 16.878 20.3149 15.7861C20.7672 14.6941 21 13.5238 21 12.3419C21 9.95497 20.0518 7.66579 18.364 5.97796C16.6761 4.29013 14.3869 3.34192 12 3.34192C9.61305 3.34192 7.32387 4.29013 5.63604 5.97796C3.94821 7.66579 3 9.95497 3 12.3419Z"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.34192V12.3419L15 15.3419"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49_684">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.341919)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MapIcon = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_49_688)">
        <path
          d="M3 7.34192L9 4.34192L15 7.34192L21 4.34192V17.3419L15 20.3419L9 17.3419L3 20.3419V7.34192Z"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.34192V17.3419"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 7.34192V20.3419"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49_688">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.341919)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LocationIcon = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_49_692)">
        <path
          d="M21.0001 3.34192L14.5001 21.3419C14.4562 21.4377 14.3858 21.5188 14.2971 21.5757C14.2085 21.6326 14.1054 21.6628 14.0001 21.6628C13.8948 21.6628 13.7917 21.6326 13.703 21.5757C13.6144 21.5188 13.5439 21.4377 13.5001 21.3419L10.0001 14.3419L3.00007 10.8419C2.90433 10.798 2.8232 10.7276 2.76632 10.639C2.70944 10.5503 2.6792 10.4472 2.6792 10.3419C2.6792 10.2366 2.70944 10.1335 2.76632 10.0449C2.8232 9.95623 2.90433 9.88579 3.00007 9.84192L21.0001 3.34192Z"
          stroke="#222222"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49_692">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.341919)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowDownHeaderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9197 8.17999H11.6897H6.07975C5.11975 8.17999 4.63975 9.33999 5.31975 10.02L10.4997 15.2C11.3297 16.03 12.6797 16.03 13.5097 15.2L15.4797 13.23L18.6897 10.02C19.3597 9.33999 18.8797 8.17999 17.9197 8.17999Z"
        fill="#443F4D"
      />
    </svg>
  );
};

export const EnglishLogo = () => {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_260_975)">
        <path
          d="M31.25 40H8.75C3.9175 40 0 36.0825 0 31.25V8.75C0 3.9175 3.9175 0 8.75 0H31.25C36.0825 0 40 3.9175 40 8.75V31.25C40 36.0825 36.0825 40 31.25 40Z"
          fill="#41479B"
        />
        <path
          d="M40.0003 31.2491V29.3283L33.7957 25.2632H40.0003V23.1579H23.1582V40H25.2634V27.2234L38.6175 35.9727C39.0905 35.2363 39.4556 34.4242 39.6917 33.5589"
          fill="#F5F5F5"
        />
        <path
          d="M0.588359 34.4096C0.801484 34.9596 1.0682 35.4829 1.38273 35.9727L14.7368 27.2234V40H16.842V23.1579H0V25.2632H6.20461L0 29.3283V31.25C0 31.5864 0.0196875 31.9182 0.0566406 32.2448"
          fill="#F5F5F5"
        />
        <path
          d="M0 9.04742V10.6717L6.20461 14.7369H0V16.8421H16.8421V0H14.7369V12.7766L1.38273 4.02734C0.86375 4.83539 0.474453 5.73453 0.243281 6.69531"
          fill="#F5F5F5"
        />
        <path
          d="M39.4004 5.56008C39.1893 5.02109 38.9263 4.50805 38.6175 4.02727L25.2634 12.7766V0H23.1582V16.8421H40.0003V14.7369H33.7957L40.0003 10.6717V8.75C40.0003 8.40156 39.9793 8.05797 39.9397 7.72016"
          fill="#F5F5F5"
        />
        <path
          d="M23.1579 0H16.8421V16.8421H0V23.1579H16.8421V40H23.1579V23.1579H40V16.8421H23.1579V0Z"
          fill="#FF4B55"
        />
        <path
          d="M10.8121 25.2632L0.0566406 32.2448C0.142109 32.9997 0.323359 33.7255 0.588437 34.4096L14.679 25.2631L10.8121 25.2632Z"
          fill="#FF4B55"
        />
        <path
          d="M26.9111 25.2632L39.6913 33.559C39.892 32.8233 39.9998 32.0493 39.9998 31.25V31.2491L30.778 25.2631L26.9111 25.2632Z"
          fill="#FF4B55"
        />
        <path
          d="M12.6316 14.7369L0.243281 6.69531C0.0846094 7.35438 0 8.04227 0 8.75V9.04742L8.76469 14.7369H12.6316Z"
          fill="#FF4B55"
        />
        <path
          d="M29.1295 14.7369L39.9389 7.72015C39.8505 6.96671 39.6669 6.24249 39.3996 5.56015L25.2627 14.7369H29.1295Z"
          fill="#FF4B55"
        />
      </g>
      <rect x="0.5" y="0.5" width={39} height={39} rx="7.5" stroke="white" />
      <defs>
        <clipPath id="clip0_260_975">
          <rect width={40} height={40} rx={8} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlusCircleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="#9453FF"
      />
      <path
        d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
        fill="#9453FF"
      />
      <path
        d="M12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16C12.75 16.41 12.41 16.75 12 16.75Z"
        fill="#9453FF"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_584_1156)">
        <path
          d="M8 4.12903V13.4624"
          stroke="#9453FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33331 8.79565H12.6666"
          stroke="#9453FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_584_1156">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(0 0.795654)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MinusIcon = () => {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_584_707)">
        <path
          d="M3.33331 8.79565H12.6666"
          stroke="#9453FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_584_707">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(0 0.795654)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_105_8132)">
        <path
          d="M4 7.79565H20"
          stroke="#D60000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.7957V17.7957"
          stroke="#D60000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11.7957V17.7957"
          stroke="#D60000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7.79565L6 19.7957C6 20.3261 6.21071 20.8348 6.58579 21.2099C6.96086 21.5849 7.46957 21.7957 8 21.7957H16C16.5304 21.7957 17.0391 21.5849 17.4142 21.2099C17.7893 20.8348 18 20.3261 18 19.7957L19 7.79565"
          stroke="#D60000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 7.79565V4.79565C9 4.53044 9.10536 4.27608 9.29289 4.08855C9.48043 3.90101 9.73478 3.79565 10 3.79565H14C14.2652 3.79565 14.5196 3.90101 14.7071 4.08855C14.8946 4.27608 15 4.53044 15 4.79565V7.79565"
          stroke="#D60000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_105_8132">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.795654)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PrevIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clippath="url(#clip0_1535_15939)">
        <path
          d="M15 6L9 12L15 18"
          stroke="white"
          strokewidth="{1.5}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1535_15939">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NextIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clippath="url(#clip0_1535_15945)">
        <path
          d="M9 6L15 12L9 18"
          stroke="white"
          strokewidth="{1.5}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1535_15945">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconEditImageUser = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_887_4647)">
      <path
        d="M5.16602 5.16669H4.49935C4.14573 5.16669 3.80659 5.30716 3.55654 5.55721C3.30649 5.80726 3.16602 6.1464 3.16602 6.50002V12.5C3.16602 12.8536 3.30649 13.1928 3.55654 13.4428C3.80659 13.6929 4.14573 13.8334 4.49935 13.8334H10.4993C10.853 13.8334 11.1921 13.6929 11.4422 13.4428C11.6922 13.1928 11.8327 12.8536 11.8327 12.5V11.8334"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.09 4.89001C14.3526 4.62745 14.5001 4.27133 14.5001 3.90001C14.5001 3.52869 14.3526 3.17257 14.09 2.91001C13.8274 2.64745 13.4713 2.49994 13.1 2.49994C12.7287 2.49994 12.3726 2.64745 12.11 2.91001L6.5 8.50001V10.5H8.5L14.09 4.89001Z"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.166 3.83331L13.166 5.83331"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_887_4647">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconLocation = ({ width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1362_20465)">
      <path
        d="M21.7496 3L15.2496 21C15.2057 21.0957 15.1353 21.1769 15.0466 21.2338C14.958 21.2906 14.8549 21.3209 14.7496 21.3209C14.6443 21.3209 14.5412 21.2906 14.4525 21.2338C14.3639 21.1769 14.2935 21.0957 14.2496 21L10.7496 14L3.74958 10.5C3.65384 10.4561 3.57271 10.3857 3.51583 10.2971C3.45895 10.2084 3.42871 10.1053 3.42871 10C3.42871 9.89468 3.45895 9.79158 3.51583 9.70295C3.57271 9.61431 3.65384 9.54387 3.74958 9.5L21.7496 3Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_20465">
        <rect width="24" height="24" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconClock = ({ width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1362_20455)">
      <path
        d="M3.25 12C3.25 13.1819 3.48279 14.3522 3.93508 15.4442C4.38738 16.5361 5.05031 17.5282 5.88604 18.364C6.72177 19.1997 7.71392 19.8626 8.80585 20.3149C9.89778 20.7672 11.0681 21 12.25 21C13.4319 21 14.6022 20.7672 15.6942 20.3149C16.7861 19.8626 17.7782 19.1997 18.614 18.364C19.4497 17.5282 20.1126 16.5361 20.5649 15.4442C21.0172 14.3522 21.25 13.1819 21.25 12C21.25 9.61305 20.3018 7.32387 18.614 5.63604C16.9261 3.94821 14.6369 3 12.25 3C9.86305 3 7.57387 3.94821 5.88604 5.63604C4.19821 7.32387 3.25 9.61305 3.25 12Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 7V12L15.25 15"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_20455">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconTicket = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_887_5763)">
      <path
        d="M15 5V7"
        stroke="#605D67"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11V13"
        stroke="#605D67"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 17V19"
        stroke="#605D67"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V10C20.4696 10 19.9609 10.2107 19.5858 10.5858C19.2107 10.9609 19 11.4696 19 12C19 12.5304 19.2107 13.0391 19.5858 13.4142C19.9609 13.7893 20.4696 14 21 14V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V14C3.53043 14 4.03914 13.7893 4.41421 13.4142C4.78929 13.0391 5 12.5304 5 12C5 11.4696 4.78929 10.9609 4.41421 10.5858C4.03914 10.2107 3.53043 10 3 10V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5Z"
        stroke="#605D67"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_887_5763">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clipPath="url(#clip0_887_5693)">
      <path
        d="M4.66699 10.5H16.3337"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 15.5L16.333 10.5"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 5.5L16.333 10.5"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_887_5693">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = () => {
  return (
    <svg
      width={21}
      height={20}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1153_5884)">
        <path
          d="M3 8.33333C3 9.09938 3.15088 9.85792 3.44404 10.5657C3.73719 11.2734 4.16687 11.9164 4.70854 12.4581C5.25022 12.9998 5.89328 13.4295 6.60101 13.7226C7.30875 14.0158 8.06729 14.1667 8.83333 14.1667C9.59938 14.1667 10.3579 14.0158 11.0657 13.7226C11.7734 13.4295 12.4164 12.9998 12.9581 12.4581C13.4998 11.9164 13.9295 11.2734 14.2226 10.5657C14.5158 9.85792 14.6667 9.09938 14.6667 8.33333C14.6667 7.56729 14.5158 6.80875 14.2226 6.10101C13.9295 5.39328 13.4998 4.75022 12.9581 4.20854C12.4164 3.66687 11.7734 3.23719 11.0657 2.94404C10.3579 2.65088 9.59938 2.5 8.83333 2.5C8.06729 2.5 7.30875 2.65088 6.60101 2.94404C5.89328 3.23719 5.25022 3.66687 4.70854 4.20854C4.16687 4.75022 3.73719 5.39328 3.44404 6.10101C3.15088 6.80875 3 7.56729 3 8.33333Z"
          stroke="white"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 17.5L13 12.5"
          stroke="white"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1153_5884">
          <rect
            width={20}
            height={20}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotFoundIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 258 212"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.008 101.344C112.531 99.8209 115 99.8209 116.523 101.344L146.992 131.813C148.515 133.336 148.515 135.805 146.992 137.328C145.469 138.851 143 138.851 141.477 137.328L111.008 106.859C109.485 105.336 109.485 102.867 111.008 101.344Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M146.992 101.344C148.515 102.867 148.515 105.336 146.992 106.859L116.523 137.328C115 138.851 112.531 138.851 111.008 137.328C109.485 135.805 109.485 133.336 111.008 131.813L141.477 101.344C143 99.8209 145.469 99.8209 146.992 101.344Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.178223 10.1563C0.178223 5.1917 4.20185 1.17822 9.15635 1.17822H189.892C192.046 1.17822 193.792 2.92431 193.792 5.07822C193.792 7.23213 192.046 8.97822 189.892 8.97822H9.15635C8.50459 8.97822 7.97822 9.50459 7.97822 10.1563V187.891C7.97822 188.54 8.50713 189.069 9.15635 189.069H41.7681C43.922 189.069 45.6681 190.815 45.6681 192.969C45.6681 195.123 43.922 196.869 41.7681 196.869H9.15635C4.19931 196.869 0.178223 192.848 0.178223 187.891V10.1563Z"
        fill="#E5E3E8"
      />
      <path
        d="M210.207 10.1563C216.742 10.1563 216.753 0 210.207 0C203.672 0 203.661 10.1563 210.207 10.1563Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M226.619 5.07822C226.619 2.92431 228.365 1.17822 230.519 1.17822H248.844C253.798 1.17822 257.822 5.1917 257.822 10.1563V187.891C257.822 192.848 253.801 196.869 248.844 196.869H69.7281C67.5742 196.869 65.8281 195.123 65.8281 192.969C65.8281 190.815 67.5742 189.069 69.7281 189.069H248.844C249.493 189.069 250.022 188.54 250.022 187.891V10.1563C250.022 9.50459 249.495 8.97822 248.844 8.97822H230.519C228.365 8.97822 226.619 7.23213 226.619 5.07822Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.5576 151.928L46.4604 193.025C44.0174 195.468 44.0174 199.427 46.4604 201.87C48.9033 204.313 52.868 204.313 55.3109 201.87L96.4031 160.778L101.919 166.294L60.8264 207.386C55.3373 212.875 46.434 212.875 40.9449 207.386C35.4559 201.897 35.4559 192.998 40.9449 187.509L82.0422 146.412L87.5576 151.928Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.8032 25.3897C40.8032 23.2358 42.5493 21.4897 44.7032 21.4897H92.889C95.0429 21.4897 96.789 23.2358 96.789 25.3897C96.789 27.5437 95.0429 29.2897 92.889 29.2897H44.7032C42.5493 29.2897 40.8032 27.5437 40.8032 25.3897Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M253.922 49.6022H4.07812V41.8022H253.922V49.6022Z"
        fill="#E5E3E8"
      />
      <path
        d="M24.3906 30.4678C30.9257 30.4678 30.9363 20.3115 24.3906 20.3115C17.8556 20.3115 17.8449 30.4678 24.3906 30.4678Z"
        fill="#E5E3E8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M129 69.9147C101.706 69.9147 79.5798 92.041 79.5798 119.335C79.5798 146.629 101.706 168.755 129 168.755C156.294 168.755 178.42 146.629 178.42 119.335C178.42 92.041 156.294 69.9147 129 69.9147ZM71.7798 119.335C71.7798 87.7331 97.3982 62.1147 129 62.1147C160.602 62.1147 186.22 87.7331 186.22 119.335C186.22 150.937 160.602 176.555 129 176.555C97.3982 176.555 71.7798 150.937 71.7798 119.335Z"
        fill="#E5E3E8"
      />
    </svg>
  );
};

export const IconEditDetail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 13"
      fill="none"
    >
      <g clippath="url(#clip0_1466_7482)">
        <path
          d="M3.5 4.47021H3C2.73478 4.47021 2.48043 4.57557 2.29289 4.76311C2.10536 4.95065 2 5.205 2 5.47022V9.97023C2 10.2354 2.10536 10.4898 2.29289 10.6773C2.48043 10.8649 2.73478 10.9702 3 10.9702H7.50001C7.76523 10.9702 8.01958 10.8649 8.20712 10.6773C8.39466 10.4898 8.50001 10.2354 8.50001 9.97023V9.47022"
          stroke="#9453FF"
          strokewidth="{1.125}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1925 4.26277C10.3894 4.06585 10.5001 3.79876 10.5001 3.52027C10.5001 3.24178 10.3894 2.97469 10.1925 2.77777C9.99559 2.58085 9.7285 2.47021 9.45001 2.47021C9.17152 2.47021 8.90443 2.58085 8.70751 2.77777L4.5 6.97028V8.47028H6L10.1925 4.26277Z"
          stroke="#9453FF"
          strokewidth="{1.125}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 3.47021L9.5 4.97022"
          stroke="#9453FF"
          strokewidth="{1.125}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1466_7482">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.970215)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconCalendar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1362_20450)">
      <path
        d="M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3V7"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3V7"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 11H20"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15H12"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15V18"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_20450">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconMap = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1362_20460)">
      <path
        d="M3.5 7L9.5 4L15.5 7L21.5 4V17L15.5 20L9.5 17L3.5 20V7Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 4V17"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 7V20"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_20460">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconCategory = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1362_20470)">
      <path
        d="M14 4H20V10H14V4Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14H10V20H4V14Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17C14 17.7956 14.3161 18.5587 14.8787 19.1213C15.4413 19.6839 16.2044 20 17 20C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17C20 16.2044 19.6839 15.4413 19.1213 14.8787C18.5587 14.3161 17.7956 14 17 14C16.2044 14 15.4413 14.3161 14.8787 14.8787C14.3161 15.4413 14 16.2044 14 17Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 7C4 7.39397 4.0776 7.78407 4.22836 8.14805C4.37913 8.51203 4.6001 8.84274 4.87868 9.12132C5.15726 9.3999 5.48797 9.62087 5.85195 9.77164C6.21593 9.9224 6.60603 10 7 10C7.39397 10 7.78407 9.9224 8.14805 9.77164C8.51203 9.62087 8.84274 9.3999 9.12132 9.12132C9.3999 8.84274 9.62087 8.51203 9.77164 8.14805C9.9224 7.78407 10 7.39397 10 7C10 6.60603 9.9224 6.21593 9.77164 5.85195C9.62087 5.48797 9.3999 5.15726 9.12132 4.87868C8.84274 4.6001 8.51203 4.37913 8.14805 4.22836C7.78407 4.0776 7.39397 4 7 4C6.60603 4 6.21593 4.0776 5.85195 4.22836C5.48797 4.37913 5.15726 4.6001 4.87868 4.87868C4.6001 5.15726 4.37913 5.48797 4.22836 5.85195C4.0776 6.21593 4 6.60603 4 7Z"
        stroke="#1A0044"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_20470">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconButtonRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_1466_7410)">
      <path
        d="M3.83337 8.9707H13.1667"
        stroke="#9453FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16663 12.9707L13.1666 8.9707"
        stroke="#9453FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16663 4.9707L13.1666 8.9707"
        stroke="#9453FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1466_7410">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.970703)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const ChevronRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M6.5 4.5L10.5 8.5L6.5 12.5"
        stroke="#9453FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EllipseIcon = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 217 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M216.288 108.5C216.288 168.03 168.03 216.288 108.5 216.288C48.97 216.288 0.711426 168.03 0.711426 108.5C0.711426 48.97 48.97 0.711426 108.5 0.711426C168.03 0.711426 216.288 48.97 216.288 108.5ZM13.646 108.5C13.646 160.886 56.1136 203.354 108.5 203.354C160.886 203.354 203.354 160.886 203.354 108.5C203.354 56.1136 160.886 13.646 108.5 13.646C56.1136 13.646 13.646 56.1136 13.646 108.5Z"
        fill="#F6F6F7"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.94205 8.45675C8.28897 8.1193 8.75944 7.92973 9.25 7.92973C9.74055 7.92973 10.211 8.1193 10.5579 8.45675L18.5 16.1841L26.442 8.45675C26.6127 8.28483 26.8168 8.1477 27.0425 8.05336C27.2683 7.95903 27.511 7.90937 27.7567 7.90729C28.0023 7.90522 28.2459 7.95076 28.4733 8.04127C28.7006 8.13177 28.9072 8.26543 29.0809 8.43443C29.2546 8.60344 29.3919 8.80441 29.485 9.02563C29.578 9.24684 29.6248 9.48387 29.6227 9.72287C29.6205 9.96187 29.5695 10.1981 29.4725 10.4177C29.3756 10.6373 29.2346 10.8359 29.0579 11.0019L21.1159 18.7293L29.0579 26.4567C29.3949 26.7962 29.5814 27.2509 29.5772 27.7229C29.573 28.1948 29.3784 28.6463 29.0354 28.98C28.6924 29.3138 28.2284 29.5031 27.7433 29.5072C27.2583 29.5113 26.791 29.3298 26.442 29.0019L18.5 21.2745L10.5579 29.0019C10.209 29.3298 9.74172 29.5113 9.25665 29.5072C8.77159 29.5031 8.30759 29.3138 7.96458 28.98C7.62158 28.6463 7.42701 28.1948 7.4228 27.7229C7.41858 27.2509 7.60505 26.7962 7.94205 26.4567L15.8841 18.7293L7.94205 11.0019C7.59522 10.6644 7.40039 10.2066 7.40039 9.72935C7.40039 9.25205 7.59522 8.7943 7.94205 8.45675Z"
        fill="#605D67"
      />
    </svg>
  );
};
export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_1709_1984)">
        <path
          d="M2.6665 3.1665H13.3332V4.6145C13.3331 4.9681 13.1926 5.30718 12.9425 5.55717L9.99984 8.49984V13.1665L5.99984 14.4998V8.83317L3.01317 5.54784C2.79014 5.30245 2.66654 4.98277 2.6665 4.65117V3.1665Z"
          stroke="#9453FF"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1709_1984">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconSuccess = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
    >
      <g clippath="url(#clip0_1556_26086)">
        <path
          d="M5.51114 42.6331C5.58446 42.8166 5.62079 43.0129 5.61803 43.2105C5.61527 43.4081 5.57348 43.6033 5.49506 43.7847C5.41664 43.9661 5.30313 44.1303 5.16107 44.2677C5.019 44.4051 4.85118 44.5131 4.66725 44.5855C4.48331 44.6578 4.28689 44.6931 4.08928 44.6893C3.89166 44.6855 3.69675 44.6426 3.51573 44.5633C3.33472 44.4839 3.17119 44.3695 3.03452 44.2267C2.89786 44.0839 2.79076 43.9155 2.71939 43.7312C0.435841 37.9299 -0.103718 31.5879 1.16698 25.4842C2.43767 19.3805 5.46329 13.7808 9.87226 9.37271C20.6824 -1.43729 37.4873 -3.02066 50.0305 5.22271L49.5613 2.92271C49.4817 2.53291 49.5602 2.12747 49.7796 1.79557C49.999 1.46368 50.3412 1.23253 50.731 1.15296C51.1208 1.0734 51.5263 1.15194 51.8582 1.37131C52.19 1.59068 52.4212 1.93291 52.5008 2.32271L53.9014 9.18846C53.9451 9.40273 53.9415 9.62396 53.8907 9.83667C53.8399 10.0494 53.7432 10.2484 53.6074 10.4198C53.4716 10.5912 53.3 10.7309 53.1046 10.829C52.9091 10.9271 52.6946 10.9812 52.476 10.9877L45.4719 11.1948C45.4569 11.1948 45.4418 11.1948 45.4268 11.1948C45.0289 11.2006 44.6451 11.0481 44.3597 10.7709C44.0743 10.4937 43.9108 10.1144 43.905 9.71659C43.8992 9.31876 44.0517 8.93494 44.329 8.64956C44.6062 8.36417 44.9854 8.20061 45.3833 8.19484L48.9208 8.09034C37.5014 0.218213 21.9453 1.54246 11.9936 11.4941C7.99777 15.4891 5.25566 20.5641 4.10405 26.0959C2.95245 31.6277 3.4415 37.3754 5.51114 42.6331ZM58.6463 13.5427C58.4148 13.2222 58.0663 13.006 57.6763 12.9412C57.2864 12.8763 56.8866 12.968 56.5639 13.1963C56.2411 13.4246 56.0216 13.771 55.9529 14.1603C55.8843 14.5496 55.9721 14.9503 56.1973 15.2752C60.3856 21.2098 62.1946 28.4999 61.2665 35.704C60.3385 42.9082 56.7409 49.5018 51.1853 54.1811C45.6296 58.8604 38.5204 61.2847 31.2633 60.9745C24.0063 60.6643 17.1298 57.6423 11.9936 52.5061C11.5873 52.0997 11.1924 51.6807 10.8089 51.2491L14.2391 51.9491C14.6289 52.0287 15.0344 51.9501 15.3663 51.7307C15.6982 51.5114 15.9293 51.1691 16.0089 50.7793C16.0885 50.3895 16.0099 49.9841 15.7905 49.6522C15.5712 49.3203 15.2289 49.0892 14.8391 49.0096L8.00814 47.616C7.79391 47.5723 7.57272 47.5759 7.36006 47.6267C7.1474 47.6775 6.9484 47.7741 6.77701 47.9099C6.60562 48.0456 6.46598 48.2172 6.36787 48.4126C6.26975 48.6079 6.21553 48.8224 6.20901 49.041L6.00289 56.0091C5.99707 56.206 6.0301 56.4021 6.10008 56.5862C6.17006 56.7704 6.27563 56.9389 6.41075 57.0823C6.54587 57.2256 6.7079 57.3409 6.88759 57.4217C7.06728 57.5024 7.26111 57.5469 7.45801 57.5527C7.47314 57.5527 7.48814 57.5535 7.50314 57.5535C7.89318 57.5533 8.2678 57.4012 8.54757 57.1294C8.82734 56.8576 8.99026 56.4876 9.00176 56.0977L9.06989 53.7918C9.33326 54.0748 9.59989 54.3543 9.87239 54.6272C15.5405 60.2927 23.128 63.6255 31.1349 63.9665C39.1417 64.3075 46.9851 61.6321 53.1145 56.469C59.2438 51.306 63.213 44.0312 64.2373 36.0828C65.2615 28.1344 63.2664 20.091 58.6463 13.5427ZM49.2213 36.2697C48.9208 37.1967 48.5473 38.0984 48.1044 38.9663L50.0301 42.128C50.2051 42.4151 50.2784 42.7527 50.2385 43.0866C50.1985 43.4204 50.0475 43.7312 49.8098 43.969L45.011 48.7681C44.7732 49.0058 44.4625 49.1568 44.1286 49.1967C43.7948 49.2367 43.4572 49.1633 43.17 48.9883L40.0075 47.0625C39.1396 47.5054 38.2379 47.8789 37.311 48.1795L36.4373 51.7771C36.3579 52.1038 36.171 52.3944 35.9067 52.6022C35.6424 52.81 35.3159 52.923 34.9796 52.923H28.1934C27.8572 52.923 27.5307 52.81 27.2663 52.6022C27.002 52.3944 26.8151 52.1038 26.7358 51.7771L25.8623 48.1795C24.9354 47.8788 24.0337 47.5053 23.1658 47.0625L20.0035 48.9883C19.7164 49.1633 19.3788 49.2367 19.0449 49.1967C18.711 49.1568 18.4003 49.0058 18.1625 48.7681L13.3635 43.969C13.1258 43.7312 12.9748 43.4204 12.9348 43.0866C12.8948 42.7527 12.9682 42.4151 13.1431 42.128L15.069 38.9662C14.626 38.0983 14.2525 37.1966 13.952 36.2697L10.3545 35.3958C10.0277 35.3164 9.73705 35.1295 9.52924 34.8651C9.32143 34.6006 9.20852 34.274 9.20864 33.9377V27.1515C9.20863 26.8152 9.3216 26.4887 9.5294 26.2244C9.7372 25.9601 10.0278 25.7732 10.3545 25.6938L13.952 24.82C14.2526 23.893 14.6261 22.9913 15.069 22.1233L13.1431 18.9608C12.9682 18.6737 12.8949 18.3361 12.9349 18.0023C12.9748 17.6684 13.1258 17.3577 13.3635 17.12L18.1623 12.3216C18.4 12.0839 18.7107 11.9329 19.0446 11.8929C19.3784 11.853 19.716 11.9263 20.0031 12.1012L23.1656 14.0271C24.0336 13.5842 24.9353 13.2107 25.8621 12.9101L26.7361 9.31259C26.8155 8.98586 27.0024 8.69527 27.2667 8.48747C27.531 8.27967 27.8575 8.16671 28.1938 8.16671H34.9805C35.3166 8.16691 35.6429 8.27998 35.9071 8.48779C36.1712 8.6956 36.3579 8.9861 36.4373 9.31271L37.3111 12.9102C38.238 13.2109 39.1397 13.5844 40.0076 14.0272L43.1701 12.1013C43.4573 11.9264 43.7949 11.853 44.1288 11.893C44.4626 11.933 44.7734 12.084 45.0111 12.3217L49.8099 17.1207C50.0476 17.3585 50.1986 17.6692 50.2385 18.003C50.2785 18.3369 50.2052 18.6744 50.0303 18.9616L48.1045 22.1241C48.5474 22.9921 48.9209 23.8938 49.2214 24.8207L52.819 25.6946C53.1457 25.774 53.4363 25.9608 53.6441 26.2252C53.8519 26.4895 53.9649 26.816 53.9649 27.1522V33.9377C53.9649 34.2739 53.8519 34.6004 53.6441 34.8648C53.4363 35.1291 53.1457 35.316 52.819 35.3953L49.2213 36.2697ZM50.9648 32.759V28.3307L47.6761 27.5318C47.4152 27.4685 47.176 27.3362 46.9835 27.1489C46.7911 26.9615 46.6525 26.7259 46.5823 26.4667C46.2369 25.1936 45.73 23.9699 45.0739 22.8255C44.9403 22.5926 44.8717 22.3282 44.8751 22.0598C44.8786 21.7914 44.954 21.5288 45.0935 21.2995L46.8546 18.4081L43.7235 15.2768L40.8329 17.0377C40.6035 17.1774 40.3408 17.253 40.0723 17.2566C39.8037 17.2601 39.5391 17.1915 39.3061 17.0578C38.1617 16.4016 36.9379 15.8946 35.6646 15.5493C35.4056 15.479 35.1701 15.3405 34.9828 15.1482C34.7955 14.9559 34.6633 14.7168 34.5999 14.456L33.8009 11.167H29.3725L28.5735 14.456C28.5101 14.7168 28.3778 14.9559 28.1905 15.1482C28.0032 15.3405 27.7677 15.4791 27.5086 15.5493C26.2355 15.8946 25.0118 16.4016 23.8674 17.0578C23.6345 17.1914 23.3701 17.2601 23.1016 17.2566C22.8332 17.2532 22.5706 17.1778 22.3413 17.0382L19.4498 15.2768L16.3185 18.4081L18.0796 21.2995C18.2192 21.5287 18.2947 21.7912 18.2982 22.0596C18.3017 22.328 18.2332 22.5924 18.0998 22.8252C17.4436 23.9696 16.9366 25.1933 16.5913 26.4665C16.521 26.7256 16.3825 26.9611 16.1901 27.1485C15.9978 27.3358 15.7587 27.4681 15.4978 27.5315L12.2089 28.3305V32.759L15.4978 33.5578C15.7587 33.6212 15.9978 33.7535 16.1901 33.9408C16.3825 34.1282 16.521 34.3637 16.5913 34.6228C16.9365 35.896 17.4435 37.1197 18.0998 38.2641C18.2333 38.4969 18.302 38.7614 18.2985 39.0298C18.2951 39.2982 18.2197 39.5608 18.0801 39.7901L16.3188 42.6815L19.4498 45.8127L22.341 44.0515C22.5704 43.9119 22.833 43.8365 23.1014 43.8331C23.3698 43.8297 23.6343 43.8983 23.8671 44.032C25.0115 44.6881 26.2352 45.1951 27.5084 45.5403C27.7675 45.6106 28.003 45.7491 28.1903 45.9415C28.3776 46.1338 28.5098 46.3728 28.5733 46.6337L29.3723 49.9228H33.8006L34.5996 46.6337C34.663 46.3729 34.7953 46.1338 34.9826 45.9415C35.1698 45.7492 35.4053 45.6106 35.6644 45.5403C36.9376 45.1951 38.1614 44.6881 39.3058 44.0318C39.5388 43.8982 39.8034 43.8295 40.072 43.8331C40.3405 43.8366 40.6032 43.9122 40.8326 44.052L43.7235 45.8127L46.8546 42.6813L45.0935 39.7901C44.954 39.5607 44.8786 39.2981 44.8752 39.0297C44.8717 38.7612 44.9404 38.4968 45.074 38.264C45.7302 37.1196 46.2371 35.896 46.5823 34.6228C46.6526 34.3637 46.7912 34.1281 46.9836 33.9408C47.176 33.7534 47.4152 33.6212 47.6761 33.5578L50.9648 32.759ZM40.8939 30.5447C40.8939 32.3856 40.3481 34.1851 39.3254 35.7157C38.3027 37.2463 36.8491 38.4393 35.1484 39.1437C33.4477 39.8482 31.5763 40.0325 29.7708 39.6734C27.9653 39.3142 26.3069 38.4277 25.0053 37.126C23.7036 35.8244 22.8172 34.1659 22.4582 32.3604C22.0991 30.555 22.2835 28.6835 22.988 26.9829C23.6925 25.2822 24.8856 23.8286 26.4162 22.806C27.9469 21.7834 29.7464 21.2376 31.5873 21.2377C34.0547 21.2406 36.4202 22.2221 38.165 23.9669C39.9097 25.7117 40.8911 28.0773 40.8939 30.5447ZM37.8939 30.5447C37.8939 29.2972 37.524 28.0778 36.8309 27.0405C36.1378 26.0033 35.1527 25.1949 34.0002 24.7175C32.8476 24.2402 31.5794 24.1153 30.3559 24.3587C29.1324 24.6021 28.0086 25.2029 27.1265 26.085C26.2445 26.9672 25.6438 28.0911 25.4005 29.3146C25.1572 30.5381 25.2822 31.8063 25.7597 32.9588C26.2372 34.1113 27.0457 35.0963 28.083 35.7893C29.1203 36.4823 30.3398 36.8521 31.5873 36.852C33.2594 36.8499 34.8624 36.1848 36.0447 35.0023C37.227 33.8199 37.892 32.2168 37.8939 30.5447Z"
          fill="#46BD2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1556_26086">
          <rect
            width="64"
            height="64"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconTickets = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_2)">
        <path
          d="M25.0652 2.72493C24.9152 2.71493 24.7702 2.77993 24.6752 2.88993C24.5452 3.03993 24.4002 3.16993 24.2352 3.28493C23.1902 3.98993 21.7652 3.71993 21.0552 2.68493C20.8933 2.44892 20.7779 2.18419 20.7152 1.90493C20.6992 1.82715 20.6638 1.7547 20.6122 1.69436C20.5606 1.63402 20.4945 1.58776 20.4202 1.55993C20.348 1.53018 20.2697 1.51872 20.192 1.52657C20.1144 1.53442 20.0399 1.56134 19.9752 1.60493L1.91019 13.9199C1.79019 13.9999 1.71519 14.1349 1.70519 14.2849C1.69519 14.4299 1.75519 14.5799 1.86519 14.6799C1.99519 14.7949 2.11019 14.9299 2.21019 15.0799C2.55519 15.5849 2.68519 16.1949 2.57019 16.7949C2.45519 17.3949 2.11519 17.9149 1.61019 18.2599C1.26519 18.4949 0.865188 18.6299 0.465188 18.6449C0.285188 18.6499 0.125188 18.7499 0.0501877 18.9099C-0.0248123 19.0649 -0.0148123 19.2499 0.0851877 19.3949L6.61519 28.9799C6.70019 29.1049 6.84019 29.1799 6.98519 29.1899C7.13519 29.1999 7.28019 29.1399 7.38019 29.0249C7.51019 28.8749 7.65019 28.7449 7.82019 28.6349C8.86019 27.9249 10.2852 28.1949 11.0002 29.2349C11.1802 29.4949 11.3002 29.7849 11.3552 30.0899C11.3852 30.2499 11.4952 30.3849 11.6452 30.4449C11.7902 30.5099 11.9652 30.4899 12.1002 30.3949L30.4752 17.8749C30.6002 17.7899 30.6752 17.6549 30.6852 17.5049C30.69 17.432 30.678 17.359 30.6503 17.2914C30.6226 17.2238 30.5798 17.1635 30.5252 17.1149C30.3949 16.9955 30.2792 16.8613 30.1802 16.7149C29.4752 15.6749 29.7402 14.2499 30.7852 13.5399L30.7902 13.5349C31.0452 13.3599 31.3252 13.2399 31.6202 13.1849C31.7802 13.1549 31.9102 13.0449 31.9752 12.8949C32.0352 12.7449 32.0202 12.5749 31.9252 12.4399L25.4452 2.93993C25.3502 2.80993 25.2152 2.72993 25.0652 2.72493ZM30.7552 12.4449C30.6645 12.4832 30.576 12.5266 30.4902 12.5749L30.4852 12.5799C30.4052 12.6299 30.3152 12.6849 30.2352 12.7399L30.2302 12.7449C30.0202 12.8899 29.8352 13.0499 29.6702 13.2249C29.6152 13.2849 29.5652 13.3449 29.5152 13.4049C29.4452 13.4899 29.3802 13.5749 29.3252 13.6649C29.1608 13.9287 29.0314 14.2128 28.9402 14.5099V14.5149C28.9102 14.6149 28.8852 14.7199 28.8702 14.8199C28.8102 15.1299 28.8002 15.4449 28.8302 15.7499C28.8402 15.8149 28.8452 15.8799 28.8602 15.9449C28.9302 16.3999 29.1002 16.8399 29.3752 17.2499C29.4102 17.2999 29.4402 17.3349 29.4702 17.3799L29.4752 17.3849L12.0902 29.2299C12.0102 29.0449 11.9102 28.8649 11.7902 28.6899C11.3044 27.9784 10.5561 27.4887 9.70956 27.3284C8.86304 27.1681 7.98751 27.3503 7.27519 27.8349C7.21519 27.8749 7.15519 27.9249 7.09519 27.9699L7.09019 27.9649L1.29519 19.4649C1.59519 19.3699 1.88519 19.2349 2.15019 19.0499C2.28519 18.9599 2.41519 18.8599 2.53019 18.7449C2.65019 18.6349 2.75519 18.5199 2.85519 18.3949C3.18519 17.9849 3.41519 17.4949 3.51519 16.9649C3.61019 16.4349 3.58519 15.8949 3.42519 15.3949C3.38019 15.2399 3.32519 15.0899 3.25019 14.9499C3.17519 14.8099 3.10019 14.6699 3.00519 14.5349C2.97519 14.4899 2.94519 14.4499 2.91019 14.4049L2.91519 14.3999L19.9952 2.75993C20.0702 2.91993 20.1552 3.07493 20.2602 3.21993C20.4502 3.49993 20.6752 3.73493 20.9252 3.92993C20.9302 3.92493 20.9302 3.92493 20.9302 3.93493C21.2652 4.20493 21.6452 4.38993 22.0402 4.50493C22.1402 4.53493 22.2452 4.55993 22.3452 4.57493C22.4452 4.59493 22.5452 4.60493 22.6552 4.61993C23.0702 4.66493 23.4902 4.61993 23.9002 4.49493L23.9052 4.48993C23.9802 4.46493 24.0552 4.43993 24.1302 4.40993C24.4314 4.29889 24.7119 4.13835 24.9602 3.93493L30.7552 12.4449Z"
          fill="#E1D7C6"
        />
        <path
          d="M24.7749 4.07989C24.5699 4.21989 24.3549 4.33489 24.1249 4.41989C24.0499 4.44489 23.9749 4.47489 23.8999 4.49989H23.8949C23.4849 4.62489 23.0649 4.66989 22.6499 4.62489C22.5399 4.60989 22.4399 4.59989 22.3399 4.57989C22.2399 4.55989 22.1349 4.53989 22.0349 4.50989C21.6349 4.39489 21.2549 4.20489 20.9249 3.93989C20.9249 3.93489 20.9249 3.93489 20.9199 3.93489C20.6699 3.73989 20.4449 3.49989 20.2549 3.22489C20.1549 3.07989 20.0649 2.92489 19.9899 2.76489L2.91492 14.4049L2.90992 14.4099C2.94492 14.4499 2.97492 14.4949 3.00492 14.5399C3.09492 14.6749 3.17492 14.8149 3.24992 14.9549C3.32492 15.0949 3.37992 15.2449 3.42492 15.3999C3.58492 15.8999 3.61492 16.4349 3.51492 16.9699C3.41709 17.494 3.19026 17.9854 2.85492 18.3999C2.75492 18.5249 2.64492 18.6399 2.52992 18.7499C2.41492 18.8649 2.28492 18.9649 2.14992 19.0549C1.88492 19.2349 1.59492 19.3749 1.29492 19.4699L7.08992 27.9699L7.09492 27.9749C7.15492 27.9299 7.21492 27.8799 7.27492 27.8399C7.98725 27.3553 8.86278 27.1731 9.70929 27.3334C10.5558 27.4937 11.3041 27.9834 11.7899 28.6949C11.9099 28.8699 12.0099 29.0499 12.0899 29.2349L29.4699 17.3899L29.4649 17.3849C29.4349 17.3399 29.4049 17.3049 29.3699 17.2549C29.0949 16.8499 28.9249 16.4049 28.8549 15.9499C28.8449 15.8799 28.8349 15.8199 28.8249 15.7549C28.7949 15.4499 28.8099 15.1299 28.8649 14.8249C28.8849 14.7249 28.9049 14.6199 28.9349 14.5199V14.5149C28.9949 14.3199 29.0649 14.1299 29.1649 13.9449C29.2099 13.8499 29.2649 13.7549 29.3199 13.6699C29.3749 13.5799 29.4349 13.4899 29.5099 13.4099C29.5599 13.3449 29.6149 13.2849 29.6649 13.2299C29.8299 13.0549 30.0149 12.8949 30.2249 12.7499L30.2299 12.7449C30.3149 12.6899 30.3999 12.6349 30.4799 12.5849L30.4849 12.5799C30.5749 12.5299 30.6599 12.4899 30.7499 12.4499L24.9549 3.94489C24.8999 3.98989 24.8399 4.03489 24.7749 4.07989ZM28.0599 14.0199C28.0488 14.0801 28.0268 14.1377 27.9949 14.1899C27.9549 14.2449 27.9149 14.2899 27.8599 14.3299L27.8549 14.3349L27.7599 14.3999L10.2399 26.1799L10.0649 26.2999C9.95925 26.3714 9.82967 26.3983 9.70426 26.3749C9.57886 26.3515 9.46772 26.2797 9.39492 26.1749L9.38992 26.1699L4.11492 18.3249C4.09992 18.2999 4.08492 18.2749 4.07492 18.2499C4.06492 18.2249 4.05492 18.2049 4.05492 18.1749C4.04492 18.1599 4.04492 18.1399 4.04492 18.1249C4.04062 18.1203 4.03784 18.1144 4.03694 18.1082C4.03605 18.1019 4.03709 18.0955 4.03992 18.0899C4.03992 18.0749 4.03492 18.0499 4.03992 18.0299C4.03492 18.0099 4.03992 17.9799 4.04492 17.9599C4.05992 17.8949 4.07992 17.8399 4.11492 17.7849C4.14992 17.7349 4.19492 17.6899 4.24492 17.6549L4.24992 17.6499L22.0399 5.67489C22.1799 5.57989 22.3549 5.56989 22.5049 5.62989C22.5049 5.62989 22.4999 5.63489 22.5099 5.63489C22.5599 5.65489 22.6049 5.68489 22.6399 5.72489C22.6649 5.74989 22.6849 5.77489 22.7099 5.80489L27.9949 13.6499C28.0249 13.7049 28.0549 13.7599 28.0649 13.8249C28.0699 13.8949 28.0699 13.9599 28.0599 14.0199Z"
          fill="#AD7BE9"
        />
        <path
          d="M24.7752 4.06988C24.5702 4.20988 24.3502 4.32488 24.1252 4.41488C24.0502 4.43988 23.9752 4.46988 23.9002 4.49488L23.8952 4.49988C23.4902 4.61988 23.0602 4.65988 22.6502 4.62488C22.5402 4.60988 22.4402 4.59988 22.3402 4.57988C22.2402 4.55988 22.1352 4.53988 22.0352 4.50988C21.6402 4.38988 21.2602 4.19988 20.9252 3.93988C20.9252 3.93488 20.9252 3.93488 20.9202 3.93488C20.5258 3.61607 20.208 3.21283 19.9902 2.75488L2.91016 14.3999L2.91516 14.4049C2.95016 14.4449 2.97516 14.4849 3.00516 14.5299C3.09516 14.6649 3.18016 14.8049 3.24516 14.9549C3.32016 15.0949 3.37516 15.2449 3.42016 15.3999C3.58016 15.8999 3.61016 16.4349 3.51016 16.9699C3.41232 17.494 3.18549 17.9854 2.85016 18.3999C2.75016 18.5249 2.64016 18.6399 2.52516 18.7499C2.40516 18.8549 2.28016 18.9549 2.14516 19.0499C1.88016 19.2299 1.59016 19.3699 1.28516 19.4649L1.29016 19.4699L7.08516 27.9699C7.15016 27.9199 7.21016 27.8699 7.27016 27.8299C7.98248 27.3452 8.85801 27.1631 9.70453 27.3234C10.551 27.4837 11.2993 27.9734 11.7852 28.6849C11.9052 28.8599 12.0052 29.0399 12.0852 29.2249L29.4652 17.3849L29.4702 17.3799C29.4402 17.3349 29.4052 17.2949 29.3752 17.2449C29.1114 16.8558 28.9357 16.4138 28.8602 15.9499C28.8502 15.8799 28.8402 15.8199 28.8302 15.7549C28.8002 15.4499 28.8152 15.1299 28.8702 14.8249C28.8902 14.7249 28.9102 14.6199 28.9402 14.5199V14.5149C29.0002 14.3199 29.0702 14.1299 29.1702 13.9449C29.2152 13.8499 29.2702 13.7549 29.3252 13.6699C29.3802 13.5799 29.4402 13.4899 29.5152 13.4099C29.5652 13.3449 29.6202 13.2849 29.6702 13.2299C29.8302 13.0499 30.0252 12.8849 30.2302 12.7449L30.2352 12.7399C30.3202 12.6849 30.4002 12.6349 30.4852 12.5849L30.4902 12.5799C30.5752 12.5249 30.6652 12.4849 30.7552 12.4449L30.7602 12.4399L24.9602 3.93488C24.9002 3.97988 24.8402 4.02988 24.7752 4.06988ZM29.2952 12.7899C29.1252 12.8649 28.9752 12.9549 28.8202 13.0599C28.5152 13.2699 28.2552 13.5299 28.0602 13.8249V13.8299C28.0752 13.8899 28.0702 13.9549 28.0602 14.0149C28.0491 14.075 28.027 14.1327 27.9952 14.1849C27.9602 14.2349 27.9152 14.2799 27.8652 14.3149L27.8602 14.3199L27.7652 14.3849C27.7652 14.3849 27.7602 14.3899 27.7652 14.3899C27.4152 15.2599 27.4902 16.2849 28.0602 17.1199L28.1402 17.2399L12.4802 27.9049C12.4152 27.7399 12.3202 27.5749 12.2102 27.4199C11.9846 27.0889 11.6933 26.808 11.3543 26.5947C11.0154 26.3813 10.6361 26.2401 10.2402 26.1799H10.2352L10.0702 26.2949C10.0188 26.3312 9.96071 26.3569 9.89931 26.3705C9.83791 26.3841 9.77441 26.3854 9.71252 26.3742C9.65063 26.363 9.59158 26.3396 9.53881 26.3054C9.48604 26.2712 9.4406 26.2268 9.40516 26.1749L9.40016 26.1699L9.39516 26.1749C8.95516 26.2349 8.53516 26.3899 8.14516 26.6549C8.09516 26.6899 8.03516 26.7349 7.98516 26.7749L2.76016 19.1099C3.03224 19.0255 3.29012 18.9008 3.52516 18.7399C3.73016 18.5999 3.91516 18.4399 4.07016 18.2499L4.07516 18.2449C4.06516 18.2199 4.05516 18.1999 4.05016 18.1749C4.04443 18.1588 4.04107 18.1419 4.04016 18.1249C4.03586 18.1203 4.03307 18.1144 4.03218 18.1082C4.03128 18.1019 4.03232 18.0955 4.03516 18.0899C4.03516 18.0749 4.03016 18.0499 4.03516 18.0299C4.03016 18.0099 4.03516 17.9799 4.04016 17.9599C4.05516 17.8949 4.07516 17.8399 4.11016 17.7849C4.15016 17.7299 4.19016 17.6849 4.24516 17.6449L4.25016 17.6399L4.60516 17.4049C4.67516 17.2299 4.72516 17.0499 4.76016 16.8649C4.90516 16.0949 4.73516 15.3199 4.29516 14.6699C4.27016 14.6349 4.24516 14.5949 4.21016 14.5549L19.6052 4.06988C19.8157 4.52662 20.141 4.921 20.5493 5.21455C20.9577 5.50811 21.4351 5.69083 21.9352 5.74488L22.0352 5.67488C22.1029 5.6291 22.1815 5.60179 22.263 5.59565C22.3446 5.58951 22.4263 5.60476 22.5002 5.63988C22.5002 5.63988 22.4952 5.64488 22.5052 5.64488C22.5552 5.66488 22.6002 5.69488 22.6352 5.73488C22.6402 5.73488 22.6402 5.73488 22.6452 5.73988C23.0852 5.68488 23.5152 5.52488 23.9152 5.25988C23.9702 5.21988 24.0302 5.17488 24.0752 5.13988L29.2952 12.7899Z"
          fill="#AD7BE9"
        />
        <path
          d="M10.3098 17.8551C10.3448 17.9051 10.3698 17.9451 10.3898 17.9901C10.4098 18.0301 10.4248 18.0601 10.4298 18.0851C10.4348 18.1151 10.4348 18.1351 10.4248 18.1551C10.4198 18.1701 10.4098 18.1851 10.3948 18.2001L9.56481 18.7551L11.3598 21.4201C11.3698 21.4351 11.3748 21.4551 11.3748 21.4751C11.3748 21.5001 11.3598 21.5201 11.3448 21.5501C11.3248 21.5751 11.2948 21.6051 11.2548 21.6401C11.2148 21.6751 11.1598 21.7101 11.0948 21.7551C11.0298 21.8001 10.9748 21.8301 10.9298 21.8551C10.8848 21.8801 10.8398 21.8951 10.8148 21.9051C10.7891 21.9151 10.7605 21.9151 10.7348 21.9051C10.7158 21.8998 10.6996 21.8872 10.6898 21.8701L8.89481 19.2051L8.06981 19.7651C8.05481 19.7751 8.03481 19.7851 8.01481 19.7801C7.99981 19.7801 7.97981 19.7701 7.95481 19.7501C7.93481 19.7351 7.90481 19.7151 7.87981 19.6801C7.85481 19.6501 7.82481 19.6051 7.78981 19.5601C7.75481 19.5101 7.72481 19.4651 7.70981 19.4251C7.68981 19.3851 7.67481 19.3551 7.66981 19.3301C7.66475 19.307 7.66475 19.2831 7.66981 19.2601C7.67481 19.2451 7.68981 19.2301 7.70481 19.2201L10.0298 17.6501C10.0448 17.6401 10.0648 17.6401 10.0798 17.6401C10.0948 17.6401 10.1198 17.6501 10.1448 17.6651C10.1648 17.6801 10.1948 17.7001 10.2198 17.7351C10.2448 17.7651 10.2748 17.8101 10.3098 17.8551ZM11.2498 16.9551L13.3498 20.0751C13.3598 20.0901 13.3698 20.1101 13.3648 20.1301C13.3648 20.1551 13.3548 20.1751 13.3348 20.2051C13.3148 20.2301 13.2848 20.2601 13.2498 20.2951C13.2098 20.3301 13.1548 20.3651 13.0898 20.4101C13.0248 20.4551 12.9698 20.4851 12.9198 20.5151C12.8698 20.5451 12.8348 20.5551 12.8048 20.5651C12.7748 20.5751 12.7498 20.5751 12.7298 20.5651C12.7098 20.5601 12.6898 20.5501 12.6848 20.5301L10.5798 17.4151C10.5696 17.3986 10.5644 17.3795 10.5648 17.3601C10.5648 17.3351 10.5798 17.3151 10.5998 17.2851C10.6198 17.2601 10.6498 17.2301 10.6848 17.1951C10.7248 17.1601 10.7798 17.1251 10.8448 17.0801C10.9098 17.0351 10.9648 17.0051 11.0148 16.9751C11.0548 16.9501 11.0998 16.9351 11.1298 16.9251C11.1598 16.9151 11.1848 16.9151 11.2098 16.9251C11.2248 16.9251 11.2398 16.9401 11.2498 16.9551ZM15.9748 17.5001C16.0048 17.5351 16.0398 17.5851 16.0798 17.6451C16.1098 17.6901 16.1298 17.7251 16.1498 17.7551C16.1698 17.7901 16.1798 17.8151 16.1898 17.8401C16.1998 17.8701 16.2048 17.8901 16.2098 17.9101C16.2098 17.9351 16.2098 17.9601 16.1998 17.9901C16.1948 18.0251 16.1748 18.0701 16.1448 18.1401C16.1098 18.2051 16.0648 18.2801 16.0098 18.3601C15.9498 18.4401 15.8748 18.5201 15.7898 18.6101C15.6998 18.6951 15.5998 18.7801 15.4848 18.8551C15.2598 19.0051 15.0298 19.1101 14.8048 19.1651C14.5798 19.2201 14.3498 19.2201 14.1298 19.1651C13.9098 19.1151 13.6948 19.0051 13.4848 18.8451C13.2798 18.6801 13.0848 18.4601 12.8948 18.1851C12.7048 17.9051 12.5748 17.6351 12.5048 17.3651C12.4348 17.1001 12.4148 16.8401 12.4498 16.6051C12.4848 16.3651 12.5698 16.1501 12.7048 15.9451C12.8398 15.7401 13.0198 15.5601 13.2498 15.4101C13.3398 15.3501 13.4348 15.2951 13.5298 15.2551C13.6298 15.2101 13.7198 15.1801 13.8048 15.1551C13.8948 15.1351 13.9798 15.1151 14.0598 15.1101C14.1177 15.0997 14.1769 15.0997 14.2348 15.1101C14.2748 15.1201 14.3048 15.1251 14.3198 15.1351C14.3398 15.1451 14.3598 15.1601 14.3798 15.1801C14.3998 15.2001 14.4248 15.2251 14.4498 15.2551C14.4748 15.2851 14.5048 15.3251 14.5348 15.3701C14.5698 15.4201 14.5948 15.4701 14.6148 15.5051C14.6348 15.5451 14.6498 15.5751 14.6598 15.6051C14.6598 15.6351 14.6648 15.6551 14.6598 15.6751C14.6548 15.6901 14.6448 15.7051 14.6298 15.7151C14.5998 15.7351 14.5598 15.7451 14.4998 15.7401C14.4448 15.7351 14.3698 15.7351 14.2848 15.7401C14.1948 15.7501 14.0998 15.7601 13.9948 15.7901C13.8898 15.8151 13.7748 15.8701 13.6548 15.9501C13.5248 16.0401 13.4248 16.1401 13.3598 16.2701C13.2898 16.3901 13.2548 16.5251 13.2498 16.6751C13.2448 16.8251 13.2698 16.9801 13.3248 17.1451C13.3848 17.3101 13.4748 17.4801 13.5898 17.6551C13.7198 17.8551 13.8548 18.0051 13.9898 18.1201C14.1248 18.2301 14.2598 18.3151 14.3948 18.3551C14.5298 18.4001 14.6648 18.4051 14.8048 18.3801C14.9398 18.3551 15.0698 18.3001 15.1998 18.2101C15.3198 18.1301 15.4148 18.0451 15.4848 17.9601C15.5498 17.8751 15.6048 17.7901 15.6448 17.7151C15.6848 17.6451 15.7148 17.5751 15.7348 17.5201C15.7598 17.4701 15.7798 17.4301 15.7998 17.4201C15.8198 17.4101 15.8348 17.4001 15.8498 17.4001C15.8648 17.4001 15.8798 17.4101 15.8998 17.4251C15.9198 17.4401 15.9448 17.4651 15.9748 17.5001ZM19.2448 16.0951C19.2598 16.1151 19.2648 16.1351 19.2598 16.1551C19.2648 16.1751 19.2498 16.2001 19.2348 16.2251C19.2148 16.2501 19.1798 16.2851 19.1348 16.3201C19.0948 16.3601 19.0398 16.3951 18.9698 16.4451C18.8598 16.5201 18.7748 16.5701 18.7248 16.5951C18.6698 16.6151 18.6248 16.6301 18.5948 16.6251C18.5631 16.6212 18.5325 16.611 18.5048 16.5951L16.4548 15.7051L17.5098 17.2701C17.5248 17.2901 17.5298 17.3101 17.5248 17.3301C17.5248 17.3451 17.5148 17.3751 17.4998 17.4001C17.4798 17.4251 17.4498 17.4551 17.4098 17.4901C17.3698 17.5251 17.3198 17.5651 17.2498 17.6051C17.1848 17.6501 17.1298 17.6851 17.0848 17.7051C17.0398 17.7301 16.9948 17.7451 16.9698 17.7551C16.9348 17.7601 16.9098 17.7601 16.8898 17.7551C16.8694 17.75 16.8516 17.7375 16.8398 17.7201L14.7448 14.6101C14.7298 14.5901 14.7248 14.5701 14.7298 14.5501C14.7298 14.5251 14.7398 14.5051 14.7648 14.4801C14.7848 14.4551 14.8148 14.4251 14.8548 14.3901C14.8898 14.3601 14.9448 14.3151 15.0098 14.2751C15.0798 14.2301 15.1298 14.2001 15.1798 14.1701C15.2298 14.1501 15.2648 14.1301 15.2998 14.1251C15.3298 14.1151 15.3498 14.1151 15.3748 14.1201C15.3898 14.1251 15.4098 14.1351 15.4248 14.1551L16.3698 15.5601L16.3898 13.5051C16.3898 13.4751 16.3898 13.4451 16.3948 13.4201C16.4048 13.3951 16.4198 13.3701 16.4398 13.3401C16.4598 13.3151 16.4898 13.2851 16.5348 13.2551C16.5698 13.2251 16.6248 13.1801 16.6948 13.1401C16.7648 13.0951 16.8198 13.0551 16.8648 13.0351C16.9098 13.0101 16.9548 12.9951 16.9798 12.9851C17.0148 12.9801 17.0398 12.9801 17.0598 12.9851C17.0798 12.9951 17.0948 13.0001 17.1098 13.0201C17.1298 13.0501 17.1398 13.0801 17.1448 13.1251C17.1498 13.1701 17.1548 13.2351 17.1548 13.3301L17.0448 15.1301L19.0348 15.9551C19.1248 16.0001 19.1748 16.0301 19.1998 16.0501L19.2448 16.0951ZM21.4448 14.2001C21.4698 14.2301 21.4998 14.2651 21.5348 14.3201C21.5698 14.3701 21.5898 14.4101 21.6098 14.4501C21.6298 14.4851 21.6398 14.5201 21.6448 14.5451C21.6498 14.5701 21.6448 14.5901 21.6448 14.6101C21.6398 14.6251 21.6248 14.6401 21.6098 14.6501L19.9548 15.7701C19.8998 15.8101 19.8398 15.8201 19.7798 15.8151C19.7198 15.8101 19.6648 15.7651 19.6148 15.6901L17.6798 12.8151C17.6298 12.7401 17.6148 12.6751 17.6298 12.6101C17.6448 12.5551 17.6798 12.5051 17.7348 12.4651L19.3848 11.3551C19.3998 11.3451 19.4198 11.3451 19.4348 11.3451C19.4498 11.3451 19.4748 11.3551 19.4948 11.3651C19.5148 11.3801 19.5398 11.4051 19.5648 11.4351C19.5948 11.4701 19.6248 11.5051 19.6598 11.5551C19.6948 11.6051 19.7148 11.6451 19.7348 11.6801C19.7548 11.7201 19.7648 11.7501 19.7698 11.7751C19.7748 11.8001 19.7698 11.8201 19.7698 11.8401C19.7648 11.8551 19.7548 11.8701 19.7398 11.8801L18.5598 12.6701L19.1048 13.4751L20.1048 12.8051C20.1148 12.7951 20.1348 12.7901 20.1548 12.7901C20.1748 12.7951 20.1948 12.8001 20.2148 12.8101C20.2348 12.8251 20.2648 12.8451 20.2898 12.8751C20.3516 12.9509 20.4053 13.033 20.4498 13.1201C20.4698 13.1551 20.4848 13.1851 20.4798 13.2101C20.4848 13.2351 20.4898 13.2551 20.4798 13.2751C20.4748 13.2901 20.4648 13.3051 20.4498 13.3151L19.4548 13.9901L20.0848 14.9201L21.2698 14.1201C21.2848 14.1101 21.3048 14.1001 21.3198 14.1001C21.3398 14.1051 21.3598 14.1101 21.3798 14.1201C21.3948 14.1451 21.4148 14.1651 21.4448 14.2001ZM22.4648 9.67508C22.4998 9.72508 22.5248 9.76508 22.5498 9.80508C22.5648 9.84008 22.5798 9.87508 22.5848 9.90008C22.5848 9.93008 22.5898 9.95008 22.5848 9.96508C22.5748 9.99008 22.5698 10.0001 22.5498 10.0101L21.7248 10.5701L23.5148 13.2301C23.5298 13.2501 23.5348 13.2651 23.5298 13.2901C23.5248 13.3101 23.5148 13.3351 23.4948 13.3601C23.4748 13.3851 23.4448 13.4151 23.4048 13.4501C23.3648 13.4851 23.3148 13.5251 23.2448 13.5701C23.1798 13.6101 23.1248 13.6451 23.0798 13.6651C23.0348 13.6901 22.9898 13.7051 22.9648 13.7151C22.9348 13.7251 22.9098 13.7251 22.8898 13.7201C22.8698 13.7101 22.8548 13.7051 22.8398 13.6851L21.0498 11.0251L20.2248 11.5851C20.2098 11.5951 20.1898 11.6001 20.1698 11.6001C20.148 11.5942 20.1276 11.584 20.1098 11.5701C20.0848 11.5501 20.0598 11.5301 20.0348 11.5001C20.0048 11.4651 19.9748 11.4251 19.9448 11.3751C19.9098 11.3251 19.8798 11.2801 19.8648 11.2401C19.846 11.2115 19.834 11.179 19.8298 11.1451C19.8248 11.1201 19.8198 11.1001 19.8298 11.0801C19.8348 11.0601 19.8448 11.0451 19.8648 11.0351L22.1948 9.47008C22.2098 9.46008 22.2248 9.45508 22.2448 9.45508C22.2698 9.45508 22.2898 9.46508 22.3098 9.48008C22.3298 9.49508 22.3598 9.51508 22.3848 9.55008C22.3998 9.58008 22.4298 9.62508 22.4648 9.67508Z"
          fill="#FF0060"
        />
        <path
          d="M22.6349 5.73012C22.5975 5.69243 22.5534 5.66193 22.5049 5.64012C22.4999 5.64012 22.4999 5.63512 22.4999 5.63512C22.3499 5.57512 22.1749 5.58512 22.0349 5.68012L4.24494 17.6551L4.23994 17.6601C4.18994 17.6951 4.13994 17.7401 4.10994 17.7901C4.07494 17.8401 4.05994 17.9001 4.03994 17.9651C4.03494 17.9851 4.02994 18.0101 4.03494 18.0351C4.02994 18.0551 4.03494 18.0751 4.03494 18.0951C4.02994 18.1101 4.03494 18.1201 4.03994 18.1301C4.03994 18.1451 4.04494 18.1651 4.04994 18.1801C4.04994 18.2101 4.05994 18.2301 4.06994 18.2551C4.07994 18.2801 4.09494 18.3101 4.10994 18.3301L9.38994 26.1751L9.39494 26.1801C9.54494 26.4001 9.83994 26.4601 10.0649 26.3051L10.2399 26.1851L27.7599 14.3951L27.8549 14.3301L27.8599 14.3251C27.9099 14.2901 27.9549 14.2451 27.9949 14.1851C28.0249 14.1351 28.0499 14.0801 28.0599 14.0151C28.0699 13.9551 28.0749 13.8901 28.0599 13.8301C28.0449 13.7701 28.0199 13.7101 27.9899 13.6551L22.6999 5.81512C22.6799 5.78012 22.6549 5.75512 22.6349 5.73012ZM26.9199 13.8001L9.92994 25.2351L5.18494 18.1851L22.1699 6.74512L26.9199 13.8001Z"
          fill="black"
        />
        <path
          d="M5.18506 18.1851L9.93006 25.2351L26.9201 13.8001L22.1751 6.74512L5.18506 18.1851ZM10.3901 17.9901C10.4101 18.0301 10.4251 18.0601 10.4301 18.0851C10.4351 18.1151 10.4351 18.1351 10.4251 18.1551C10.4201 18.1701 10.4101 18.1851 10.3951 18.2001L9.56506 18.7551L11.3601 21.4201C11.3701 21.4351 11.3751 21.4551 11.3751 21.4751C11.3751 21.5001 11.3601 21.5201 11.3451 21.5501C11.3251 21.5751 11.2951 21.6051 11.2551 21.6401C11.2151 21.6751 11.1601 21.7101 11.0951 21.7551C11.0301 21.8001 10.9751 21.8301 10.9301 21.8551C10.8851 21.8801 10.8401 21.8951 10.8151 21.9051C10.7893 21.9152 10.7608 21.9152 10.7351 21.9051C10.716 21.8998 10.6999 21.8873 10.6901 21.8701L8.89506 19.2051L8.07006 19.7651C8.05506 19.7751 8.03506 19.7851 8.01506 19.7801C8.00006 19.7801 7.98006 19.7701 7.95506 19.7501C7.93506 19.7351 7.90506 19.7151 7.88006 19.6801C7.85506 19.6501 7.82506 19.6051 7.79006 19.5601C7.75506 19.5101 7.72506 19.4651 7.71006 19.4251C7.69006 19.3851 7.67506 19.3551 7.67006 19.3301C7.66501 19.3071 7.66501 19.2832 7.67006 19.2601C7.67506 19.2451 7.69006 19.2301 7.70506 19.2201L10.0301 17.6501C10.0451 17.6401 10.0651 17.6401 10.0801 17.6401C10.0951 17.6401 10.1201 17.6501 10.1451 17.6651C10.1651 17.6801 10.1951 17.7001 10.2201 17.7351C10.2501 17.7701 10.2801 17.8101 10.3101 17.8601C10.3451 17.9051 10.3701 17.9451 10.3901 17.9901ZM13.3501 20.0751C13.3601 20.0901 13.3701 20.1101 13.3651 20.1301C13.3651 20.1551 13.3551 20.1751 13.3351 20.2051C13.3151 20.2301 13.2851 20.2601 13.2501 20.2951C13.2101 20.3301 13.1551 20.3651 13.0901 20.4101C13.0251 20.4551 12.9701 20.4851 12.9201 20.5151C12.8701 20.5451 12.8351 20.5551 12.8051 20.5651C12.7751 20.5751 12.7501 20.5751 12.7301 20.5651C12.7101 20.5601 12.6901 20.5501 12.6851 20.5301L10.5801 17.4151C10.5699 17.3986 10.5647 17.3795 10.5651 17.3601C10.5651 17.3351 10.5801 17.3151 10.6001 17.2851C10.6201 17.2601 10.6501 17.2301 10.6851 17.1951C10.7251 17.1601 10.7801 17.1251 10.8451 17.0801C10.9101 17.0351 10.9651 17.0051 11.0151 16.9751C11.0551 16.9501 11.1001 16.9351 11.1301 16.9251C11.1601 16.9151 11.1851 16.9151 11.2101 16.9251C11.2301 16.9301 11.2451 16.9401 11.2551 16.9601L13.3501 20.0751ZM13.9951 18.1201C14.1301 18.2301 14.2651 18.3151 14.4001 18.3551C14.5351 18.4001 14.6701 18.4051 14.8101 18.3801C14.9451 18.3551 15.0751 18.3001 15.2051 18.2101C15.3251 18.1301 15.4201 18.0451 15.4901 17.9601C15.5551 17.8751 15.6101 17.7901 15.6501 17.7151C15.6901 17.6451 15.7201 17.5751 15.7401 17.5201C15.7651 17.4701 15.7851 17.4301 15.8051 17.4201C15.8251 17.4101 15.8401 17.4001 15.8551 17.4001C15.8701 17.4001 15.8851 17.4101 15.9051 17.4251C15.9251 17.4401 15.9501 17.4651 15.9801 17.5001C16.0101 17.5351 16.0451 17.5851 16.0851 17.6451C16.1151 17.6901 16.1351 17.7251 16.1551 17.7551C16.1751 17.7901 16.1851 17.8151 16.1951 17.8401C16.2051 17.8701 16.2101 17.8901 16.2151 17.9101C16.2151 17.9351 16.2151 17.9601 16.2051 17.9901C16.2001 18.0251 16.1801 18.0701 16.1501 18.1401C16.1151 18.2051 16.0701 18.2801 16.0151 18.3601C15.9551 18.4401 15.8801 18.5201 15.7951 18.6101C15.7051 18.6951 15.6051 18.7801 15.4901 18.8551C15.2651 19.0051 15.0351 19.1101 14.8101 19.1651C14.5851 19.2201 14.3551 19.2201 14.1351 19.1651C13.9151 19.1151 13.7001 19.0051 13.4901 18.8451C13.2851 18.6801 13.0901 18.4601 12.9001 18.1851C12.7101 17.9051 12.5801 17.6351 12.5101 17.3651C12.4401 17.1001 12.4201 16.8401 12.4551 16.6051C12.4901 16.3651 12.5751 16.1501 12.7101 15.9451C12.8451 15.7401 13.0251 15.5601 13.2551 15.4101C13.3451 15.3501 13.4401 15.2951 13.5351 15.2551C13.6351 15.2101 13.7251 15.1801 13.8101 15.1551C13.9001 15.1351 13.9851 15.1151 14.0651 15.1101C14.1229 15.0997 14.1822 15.0997 14.2401 15.1101C14.2801 15.1201 14.3101 15.1251 14.3251 15.1351C14.3451 15.1451 14.3651 15.1601 14.3851 15.1801C14.4051 15.2001 14.4301 15.2251 14.4551 15.2551C14.4801 15.2851 14.5101 15.3251 14.5401 15.3701C14.5751 15.4201 14.6001 15.4701 14.6201 15.5051C14.6401 15.5451 14.6551 15.5751 14.6651 15.6051C14.6651 15.6351 14.6701 15.6551 14.6651 15.6751C14.6601 15.6901 14.6501 15.7051 14.6351 15.7151C14.6051 15.7351 14.5651 15.7451 14.5051 15.7401C14.4501 15.7351 14.3751 15.7351 14.2901 15.7401C14.2001 15.7501 14.1051 15.7601 14.0001 15.7901C13.8951 15.8151 13.7801 15.8701 13.6601 15.9501C13.5301 16.0401 13.4301 16.1401 13.3651 16.2701C13.2951 16.3901 13.2601 16.5251 13.2551 16.6751C13.2501 16.8251 13.2751 16.9801 13.3301 17.1451C13.3901 17.3101 13.4801 17.4801 13.5951 17.6551C13.7201 17.8551 13.8551 18.0051 13.9951 18.1201ZM19.2601 16.1551C19.2651 16.1751 19.2501 16.2001 19.2351 16.2251C19.2151 16.2501 19.1801 16.2851 19.1351 16.3201C19.0951 16.3601 19.0401 16.3951 18.9701 16.4451C18.8601 16.5201 18.7751 16.5701 18.7251 16.5951C18.6701 16.6151 18.6251 16.6301 18.5951 16.6251C18.5634 16.6212 18.5328 16.611 18.5051 16.5951L16.4551 15.7051L17.5101 17.2701C17.5251 17.2901 17.5301 17.3101 17.5251 17.3301C17.5251 17.3451 17.5151 17.3751 17.5001 17.4001C17.4801 17.4251 17.4501 17.4551 17.4101 17.4901C17.3701 17.5251 17.3201 17.5651 17.2501 17.6051C17.1851 17.6501 17.1301 17.6851 17.0851 17.7051C17.0401 17.7301 16.9951 17.7451 16.9701 17.7551C16.9351 17.7601 16.9101 17.7601 16.8901 17.7551C16.8696 17.75 16.8518 17.7376 16.8401 17.7201L14.7451 14.6101C14.7301 14.5901 14.7251 14.5701 14.7301 14.5501C14.7301 14.5251 14.7401 14.5051 14.7651 14.4801C14.7851 14.4551 14.8151 14.4251 14.8551 14.3901C14.8901 14.3601 14.9451 14.3151 15.0101 14.2751C15.0801 14.2301 15.1301 14.2001 15.1801 14.1701C15.2301 14.1501 15.2651 14.1301 15.3001 14.1251C15.3301 14.1151 15.3501 14.1151 15.3751 14.1201C15.3901 14.1251 15.4101 14.1351 15.4251 14.1551L16.3701 15.5601L16.3901 13.5051C16.3901 13.4751 16.3901 13.4451 16.3951 13.4201C16.4051 13.3951 16.4201 13.3701 16.4401 13.3401C16.4601 13.3151 16.4901 13.2851 16.5351 13.2551C16.5701 13.2251 16.6251 13.1801 16.6951 13.1401C16.7651 13.0951 16.8201 13.0551 16.8651 13.0351C16.9101 13.0101 16.9551 12.9951 16.9801 12.9851C17.0151 12.9801 17.0401 12.9801 17.0601 12.9851C17.0801 12.9951 17.0951 13.0001 17.1101 13.0201C17.1301 13.0501 17.1401 13.0801 17.1451 13.1251C17.1501 13.1701 17.1551 13.2351 17.1551 13.3301L17.0451 15.1301L19.0351 15.9551C19.1251 16.0001 19.1751 16.0301 19.2001 16.0501C19.2251 16.0701 19.2401 16.0851 19.2501 16.1001C19.2551 16.1151 19.2651 16.1351 19.2601 16.1551ZM20.1001 12.8051C20.1101 12.7951 20.1301 12.7901 20.1501 12.7901C20.1701 12.7951 20.1901 12.8001 20.2101 12.8101C20.2301 12.8251 20.2601 12.8451 20.2851 12.8751C20.3469 12.9509 20.4005 13.033 20.4451 13.1201C20.4651 13.1551 20.4801 13.1851 20.4751 13.2101C20.4801 13.2351 20.4851 13.2551 20.4751 13.2751C20.4701 13.2901 20.4601 13.3051 20.4451 13.3151L19.4501 13.9901L20.0801 14.9201L21.2651 14.1201C21.2801 14.1101 21.3001 14.1001 21.3151 14.1001C21.3351 14.1051 21.3551 14.1101 21.3751 14.1201C21.4001 14.1401 21.4201 14.1601 21.4501 14.1951C21.4751 14.2251 21.5051 14.2601 21.5401 14.3151C21.5751 14.3651 21.5951 14.4051 21.6151 14.4451C21.6351 14.4801 21.6451 14.5151 21.6501 14.5401C21.6551 14.5651 21.6501 14.5851 21.6501 14.6051C21.6451 14.6201 21.6301 14.6351 21.6151 14.6451L19.9601 15.7651C19.9051 15.8051 19.8451 15.8151 19.7851 15.8101C19.7251 15.8051 19.6701 15.7601 19.6201 15.6851L17.6851 12.8101C17.6351 12.7351 17.6201 12.6701 17.6351 12.6051C17.6501 12.5501 17.6851 12.5001 17.7401 12.4601L19.3901 11.3501C19.4051 11.3401 19.4251 11.3401 19.4401 11.3401C19.4551 11.3401 19.4801 11.3501 19.5001 11.3601C19.5201 11.3751 19.5451 11.4001 19.5701 11.4301C19.6001 11.4651 19.6301 11.5001 19.6651 11.5501C19.7001 11.6001 19.7201 11.6401 19.7401 11.6751C19.7601 11.7151 19.7701 11.7451 19.7751 11.7701C19.7801 11.7951 19.7751 11.8151 19.7751 11.8351C19.7701 11.8501 19.7601 11.8651 19.7451 11.8751L18.5651 12.6651L19.1101 13.4701L20.1001 12.8051ZM22.5451 9.80512C22.5601 9.84012 22.5751 9.87512 22.5801 9.90012C22.5801 9.93012 22.5851 9.95012 22.5801 9.96512C22.5701 9.99012 22.5651 10.0001 22.5451 10.0101L21.7201 10.5701L23.5101 13.2301C23.5251 13.2501 23.5301 13.2651 23.5251 13.2901C23.5201 13.3101 23.5101 13.3351 23.4901 13.3601C23.4701 13.3851 23.4401 13.4151 23.4001 13.4501C23.3601 13.4851 23.3101 13.5251 23.2401 13.5701C23.1751 13.6101 23.1201 13.6451 23.0751 13.6651C23.0301 13.6901 22.9851 13.7051 22.9601 13.7151C22.9301 13.7251 22.9051 13.7251 22.8851 13.7201C22.8651 13.7101 22.8501 13.7051 22.8351 13.6851L21.0451 11.0251L20.2201 11.5851C20.2051 11.5951 20.1851 11.6001 20.1651 11.6001C20.1433 11.5942 20.1229 11.584 20.1051 11.5701C20.0801 11.5501 20.0551 11.5301 20.0301 11.5001C20.0001 11.4651 19.9701 11.4251 19.9401 11.3751C19.9051 11.3251 19.8751 11.2801 19.8601 11.2401C19.8413 11.2116 19.8293 11.179 19.8251 11.1451C19.8201 11.1201 19.8151 11.1001 19.8251 11.0801C19.8301 11.0601 19.8401 11.0451 19.8601 11.0351L22.1901 9.47012C22.2051 9.46012 22.2201 9.45512 22.2401 9.45512C22.2651 9.45512 22.2851 9.46512 22.3051 9.48012C22.3251 9.49512 22.3551 9.51512 22.3801 9.55012C22.4101 9.58512 22.4401 9.62512 22.4751 9.68012C22.4951 9.72512 22.5251 9.77012 22.5451 9.80512Z"
          fill="#FFCB4C"
        />
        <path
          d="M5.18506 18.1851L9.93006 25.2351L26.9201 13.8001L22.1751 6.74512L5.18506 18.1851ZM25.3251 13.7801L10.5201 23.7551L6.74006 18.1351L21.5401 8.15512L25.3251 13.7801Z"
          fill="#F7BE3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_2">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconPhone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clippath="url(#clip0_2081_19158)">
        <path
          d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
          stroke="#9996A0"
          strokewidth="{1.5}"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2081_19158">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Arrow = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M7.50033 16.667L14.167 10.0003L7.50033 3.33366"
        stroke="#7C7885"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Warning = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00065 15.1668C4.04732 15.1668 0.833984 11.9535 0.833984 8.00016C0.833984 4.04683 4.04732 0.833496 8.00065 0.833496C11.954 0.833496 15.1673 4.04683 15.1673 8.00016C15.1673 11.9535 11.954 15.1668 8.00065 15.1668ZM8.00065 1.8335C4.60065 1.8335 1.83398 4.60016 1.83398 8.00016C1.83398 11.4002 4.60065 14.1668 8.00065 14.1668C11.4007 14.1668 14.1673 11.4002 14.1673 8.00016C14.1673 4.60016 11.4007 1.8335 8.00065 1.8335Z"
        fill="#292D32"
      />
      <path
        d="M8 9.16683C7.72667 9.16683 7.5 8.94016 7.5 8.66683V5.3335C7.5 5.06016 7.72667 4.8335 8 4.8335C8.27333 4.8335 8.5 5.06016 8.5 5.3335V8.66683C8.5 8.94016 8.27333 9.16683 8 9.16683Z"
        fill="#292D32"
      />
      <path
        d="M8.00065 11.3334C7.91398 11.3334 7.82732 11.3134 7.74732 11.2801C7.66732 11.2468 7.59398 11.2001 7.52732 11.1401C7.46732 11.0734 7.42065 11.0068 7.38732 10.9201C7.35398 10.8401 7.33398 10.7534 7.33398 10.6668C7.33398 10.5801 7.35398 10.4934 7.38732 10.4134C7.42065 10.3334 7.46732 10.2601 7.52732 10.1934C7.59398 10.1334 7.66732 10.0868 7.74732 10.0534C7.90732 9.98675 8.09398 9.98675 8.25398 10.0534C8.33398 10.0868 8.40732 10.1334 8.47398 10.1934C8.53398 10.2601 8.58065 10.3334 8.61398 10.4134C8.64732 10.4934 8.66732 10.5801 8.66732 10.6668C8.66732 10.7534 8.64732 10.8401 8.61398 10.9201C8.58065 11.0068 8.53398 11.0734 8.47398 11.1401C8.40732 11.2001 8.33398 11.2468 8.25398 11.2801C8.17398 11.3134 8.08732 11.3334 8.00065 11.3334Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const IconCoupon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3334 13.8333H4.66671C1.72671 13.8333 0.833374 12.94 0.833374 9.99996V9.66663C0.833374 9.39329 1.06004 9.16663 1.33337 9.16663C1.97337 9.16663 2.50004 8.63996 2.50004 7.99996C2.50004 7.35996 1.97337 6.83329 1.33337 6.83329C1.06004 6.83329 0.833374 6.60663 0.833374 6.33329V5.99996C0.833374 3.05996 1.72671 2.16663 4.66671 2.16663H11.3334C14.2734 2.16663 15.1667 3.05996 15.1667 5.99996V6.66663C15.1667 6.93996 14.94 7.16663 14.6667 7.16663C14.0267 7.16663 13.5 7.69329 13.5 8.33329C13.5 8.97329 14.0267 9.49996 14.6667 9.49996C14.94 9.49996 15.1667 9.72663 15.1667 9.99996C15.1667 12.94 14.2734 13.8333 11.3334 13.8333ZM1.83337 10.1066C1.84671 12.4 2.32004 12.8333 4.66671 12.8333H11.3334C13.56 12.8333 14.1 12.44 14.16 10.44C13.2067 10.2133 12.5 9.35329 12.5 8.33329C12.5 7.31329 13.2134 6.45329 14.1667 6.22663V5.99996C14.1667 3.61996 13.7134 3.16663 11.3334 3.16663H4.66671C2.32004 3.16663 1.84671 3.59996 1.83337 5.89329C2.78671 6.11996 3.50004 6.97996 3.50004 7.99996C3.50004 9.01996 2.78671 9.87996 1.83337 10.1066Z"
        fill="#9453FF"
      />
      <path
        d="M9.99999 10.5866C9.62666 10.5866 9.32666 10.2866 9.32666 9.91996C9.32666 9.5533 9.62666 9.2533 9.99333 9.2533C10.36 9.2533 10.66 9.5533 10.66 9.91996C10.66 10.2866 10.3733 10.5866 9.99999 10.5866Z"
        fill="#9453FF"
      />
      <path
        d="M5.99999 7.25338C5.62666 7.25338 5.32666 6.95338 5.32666 6.58671C5.32666 6.22004 5.62666 5.92004 5.99333 5.92004C6.35999 5.92004 6.65999 6.22004 6.65999 6.58671C6.65999 6.95338 6.37333 7.25338 5.99999 7.25338Z"
        fill="#9453FF"
      />
      <path
        d="M5.75334 10.9534C5.62667 10.9534 5.5 10.9067 5.4 10.8067C5.20667 10.6134 5.20667 10.2934 5.4 10.1001L9.88667 5.61338C10.08 5.42005 10.4 5.42005 10.5933 5.61338C10.7867 5.80672 10.7867 6.12672 10.5933 6.32005L6.10667 10.8067C6.01334 10.9067 5.88 10.9534 5.75334 10.9534Z"
        fill="#9453FF"
      />
    </svg>
  );
};

export const IconEditCoupon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.69332 13.0133C3.28666 13.0133 2.90666 12.8733 2.63332 12.6133C2.28666 12.2867 2.11999 11.7933 2.17999 11.26L2.42666 9.09999C2.47332 8.69333 2.71999 8.15333 3.00666 7.85999L8.47999 2.06666C9.84666 0.619992 11.2733 0.579992 12.72 1.94666C14.1667 3.31333 14.2067 4.73999 12.84 6.18666L7.36666 11.98C7.08666 12.28 6.56666 12.56 6.15999 12.6267L4.01332 12.9933C3.89999 13 3.79999 13.0133 3.69332 13.0133ZM10.62 1.93999C10.1067 1.93999 9.65999 2.25999 9.20666 2.73999L3.73332 8.53999C3.59999 8.67999 3.44666 9.01333 3.41999 9.20666L3.17332 11.3667C3.14666 11.5867 3.19999 11.7667 3.31999 11.88C3.43999 11.9933 3.61999 12.0333 3.83999 12L5.98666 11.6333C6.17999 11.6 6.49999 11.4267 6.63332 11.2867L12.1067 5.49333C12.9333 4.61333 13.2333 3.79999 12.0267 2.66666C11.4933 2.15333 11.0333 1.93999 10.62 1.93999Z"
        fill="#9453FF"
      />
      <path
        d="M11.56 7.29998C11.5466 7.29998 11.5266 7.29998 11.5133 7.29998C9.4333 7.09331 7.75996 5.51331 7.43996 3.44665C7.39996 3.17331 7.58663 2.91998 7.85996 2.87331C8.1333 2.83331 8.38663 3.01998 8.4333 3.29331C8.68663 4.90665 9.9933 6.14665 11.62 6.30665C11.8933 6.33331 12.0933 6.57998 12.0666 6.85331C12.0333 7.10665 11.8133 7.29998 11.56 7.29998Z"
        fill="#9453FF"
      />
      <path
        d="M14 15.1666H2C1.72667 15.1666 1.5 14.94 1.5 14.6666C1.5 14.3933 1.72667 14.1666 2 14.1666H14C14.2733 14.1666 14.5 14.3933 14.5 14.6666C14.5 14.94 14.2733 15.1666 14 15.1666Z"
        fill="#9453FF"
      />
    </svg>
  );
};

export const LogoFacebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M21.0886 17.6868L21.6301 14.2499H18.2949V12.0158C18.2949 11.076 18.7605 10.1577 20.2494 10.1577H21.7871V7.23092C20.8916 7.08826 19.9868 7.01107 19.0799 7C16.3349 7 14.5428 8.64867 14.5428 11.6292V14.2499H11.5V17.6868H14.5428V26H18.2949V17.6868H21.0886Z"
        fill="url(#paint0_linear_2653_16926)"
      />
      <rect
        x="0.924419"
        y="0.424419"
        width="31.1512"
        height="31.1512"
        rx="15.5756"
        stroke="url(#paint1_linear_2653_16926)"
        strokeWidth={0.848837}
      />
      <defs>
        <linearGradient
          id="paint0_linear_2653_16926"
          x1="11.5786"
          y1="5.61458"
          x2="21.2114"
          y2="8.50283"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2653_16926"
          x1="0.744445"
          y1="-2.33333"
          x2="25.738"
          y2="11.5078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LogoTwitter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_2653_16931)">
        <path
          d="M17.9296 14.9162L24.2496 7.37219H22.752L17.2643 13.9226L12.8814 7.37219H7.82617L14.4541 17.2775L7.82617 25.1886H9.32389L15.119 18.2712L19.7477 25.1886H24.8029L17.9293 14.9162H17.9296ZM15.8783 17.3648L15.2068 16.3785L9.86354 8.52997H12.1639L16.476 14.8639L17.1475 15.8503L22.7527 24.0835H20.4523L15.8783 17.3652V17.3648Z"
          fill="url(#paint0_linear_2653_16931)"
        />
      </g>
      <rect
        x="0.924419"
        y="0.424419"
        width="31.1512"
        height="31.1512"
        rx="15.5756"
        stroke="url(#paint1_linear_2653_16931)"
        strokeWidth={0.848837}
      />
      <defs>
        <linearGradient
          id="paint0_linear_2653_16931"
          x1="7.95586"
          y1="6.07308"
          x2="21.5083"
          y2="13.2245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2653_16931"
          x1="0.744445"
          y1="-2.33333"
          x2="25.738"
          y2="11.5078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <clipPath id="clip0_2653_16931">
          <rect
            width="16.9767"
            height="17.8256"
            fill="white"
            transform="translate(7.82617 7.37213)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoInstagram = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M13.1652 15.9999C13.1652 14.1591 14.6572 12.6663 16.498 12.6663C18.3389 12.6663 19.8316 14.1591 19.8316 15.9999C19.8316 17.8408 18.3389 19.3335 16.498 19.3335C14.6572 19.3335 13.1652 17.8408 13.1652 15.9999ZM11.3632 15.9999C11.3632 18.8359 13.662 21.1348 16.498 21.1348C19.334 21.1348 21.6329 18.8359 21.6329 15.9999C21.6329 13.1639 19.334 10.8651 16.498 10.8651C13.662 10.8651 11.3632 13.1639 11.3632 15.9999ZM20.6362 10.6615C20.6361 10.8988 20.7064 11.1308 20.8382 11.3282C20.97 11.5256 21.1573 11.6795 21.3765 11.7704C21.5958 11.8613 21.837 11.8852 22.0698 11.839C22.3026 11.7928 22.5165 11.6786 22.6844 11.5108C22.8523 11.3431 22.9667 11.1293 23.0131 10.8965C23.0594 10.6638 23.0358 10.4225 22.945 10.2032C22.8543 9.98385 22.7006 9.79638 22.5033 9.66444C22.306 9.53251 22.074 9.46203 21.8367 9.46194H21.8362C21.5181 9.46209 21.213 9.5885 20.988 9.81341C20.763 10.0383 20.6365 10.3433 20.6362 10.6615ZM12.458 24.1397C11.4831 24.0953 10.9532 23.9329 10.601 23.7957C10.1341 23.6139 9.80101 23.3975 9.45077 23.0477C9.10053 22.6979 8.88373 22.3651 8.70277 21.8983C8.56549 21.5463 8.40309 21.0162 8.35877 20.0412C8.31029 18.9871 8.30061 18.6705 8.30061 16C8.30061 13.3295 8.31109 13.0138 8.35877 11.9588C8.40317 10.9839 8.56677 10.4548 8.70277 10.1018C8.88453 9.6349 9.10101 9.30178 9.45077 8.95154C9.80053 8.6013 10.1333 8.3845 10.601 8.20354C10.953 8.06626 11.4831 7.90386 12.458 7.85954C13.5121 7.81106 13.8288 7.80138 16.498 7.80138C19.1673 7.80138 19.4843 7.81186 20.5392 7.85954C21.5142 7.90394 22.0432 8.06754 22.3963 8.20354C22.8632 8.3845 23.1963 8.60178 23.5465 8.95154C23.8968 9.3013 24.1128 9.6349 24.2945 10.1018C24.4318 10.4538 24.5942 10.9839 24.6385 11.9588C24.687 13.0138 24.6967 13.3295 24.6967 16C24.6967 18.6705 24.687 18.9863 24.6385 20.0412C24.5941 21.0162 24.4309 21.5461 24.2945 21.8983C24.1128 22.3651 23.8963 22.6983 23.5465 23.0477C23.1968 23.3971 22.8632 23.6139 22.3963 23.7957C22.0443 23.933 21.5142 24.0954 20.5392 24.1397C19.4852 24.1882 19.1685 24.1979 16.498 24.1979C13.8276 24.1979 13.5118 24.1882 12.458 24.1397ZM12.3752 6.0605C11.3107 6.10898 10.5832 6.27778 9.94797 6.52498C9.29005 6.78026 8.73309 7.12274 8.17653 7.67842C7.61997 8.2341 7.27837 8.79194 7.02309 9.44986C6.77589 10.0855 6.60709 10.8126 6.55861 11.8771C6.50933 12.9434 6.49805 13.2843 6.49805 15.9999C6.49805 18.7156 6.50933 19.0565 6.55861 20.1227C6.60709 21.1874 6.77589 21.9143 7.02309 22.55C7.27837 23.2075 7.62005 23.766 8.17653 24.3215C8.73301 24.8769 9.29005 25.2189 9.94797 25.4749C10.5844 25.7221 11.3107 25.8909 12.3752 25.9394C13.442 25.9879 13.7824 25.9999 16.498 25.9999C19.2137 25.9999 19.5546 25.9887 20.6208 25.9394C21.6855 25.8909 22.4124 25.7221 23.0481 25.4749C23.7056 25.2189 24.263 24.8771 24.8196 24.3215C25.3761 23.7658 25.717 23.2075 25.973 22.55C26.2202 21.9143 26.3898 21.1873 26.4375 20.1227C26.486 19.0557 26.4972 18.7156 26.4972 15.9999C26.4972 13.2843 26.486 12.9434 26.4375 11.8771C26.389 10.8125 26.2202 10.0851 25.973 9.44986C25.717 8.79234 25.3752 8.23498 24.8196 7.67842C24.2639 7.12186 23.7056 6.78026 23.0489 6.52498C22.4124 6.27778 21.6854 6.10818 20.6216 6.0605C19.5554 6.01202 19.2145 5.99994 16.4988 5.99994C13.7832 5.99994 13.442 6.01122 12.3752 6.0605Z"
        fill="url(#paint0_linear_2653_16936)"
      />
      <rect
        x="0.924419"
        y="0.424419"
        width="31.1512"
        height="31.1512"
        rx="15.5756"
        stroke="url(#paint1_linear_2653_16936)"
        strokeWidth={0.848837}
      />
      <defs>
        <linearGradient
          id="paint0_linear_2653_16936"
          x1="6.65082"
          y1="4.54161"
          x2="22.2715"
          y2="13.1918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2653_16936"
          x1="0.744445"
          y1="-2.33333"
          x2="25.738"
          y2="11.5078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LogoLink = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_2653_16937)">
        <path
          d="M13.4766 19.3721L19.4766 13.3721"
          stroke="url(#paint0_linear_2653_16937)"
          strokeWidth={1.69767}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4766 10.3721L15.9396 9.83607C16.8774 8.8984 18.1493 8.37167 19.4754 8.37177C20.8016 8.37186 22.0734 8.89877 23.0111 9.83657C23.9487 10.7744 24.4755 12.0463 24.4754 13.3724C24.4753 14.6986 23.9484 15.9704 23.0106 16.9081L22.4766 17.3721"
          stroke="url(#paint1_linear_2653_16937)"
          strokeWidth={1.69767}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4767 22.3721L17.0797 22.9061C16.131 23.8443 14.8505 24.3704 13.5162 24.3704C12.1819 24.3704 10.9015 23.8443 9.9527 22.9061C9.48506 22.4437 9.1138 21.8931 8.86042 21.2862C8.60703 20.6793 8.47656 20.0282 8.47656 19.3706C8.47656 18.7129 8.60703 18.0618 8.86042 17.4549C9.1138 16.8481 9.48506 16.2975 9.9527 15.8351L10.4767 15.3721"
          stroke="url(#paint2_linear_2653_16937)"
          strokeWidth={1.69767}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="0.924419"
        y="0.424419"
        width="31.1512"
        height="31.1512"
        rx="15.5756"
        stroke="url(#paint3_linear_2653_16937)"
        strokeWidth={0.848837}
      />
      <defs>
        <linearGradient
          id="paint0_linear_2653_16937"
          x1="13.5224"
          y1="12.9346"
          x2="18.2087"
          y2="15.5298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2653_16937"
          x1="15.5453"
          y1="7.71549"
          x2="22.5744"
          y2="11.6075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2653_16937"
          x1="8.54531"
          y1="14.7159"
          x2="15.5742"
          y2="18.6092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2653_16937"
          x1="0.744445"
          y1="-2.33333"
          x2="25.738"
          y2="11.5078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED4690" />
          <stop offset="1" stopColor="#5522CC" />
        </linearGradient>
        <clipPath id="clip0_2653_16937">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(4.47656 4.37207)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
